export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type ActiveWatchdogsResponse = {
  __typename?: 'ActiveWatchdogsResponse';
  cursor: Maybe<Scalars['Int']>;
  moreAvailable: Maybe<Scalars['Boolean']>;
  watchdogs: Maybe<Array<Maybe<ActiveWatchdogsResponse_Watchdog>>>;
};

export type ActiveWatchdogsResponse_Watchdog = {
  __typename?: 'ActiveWatchdogsResponse_Watchdog';
  catalogId: Maybe<Scalars['Int']>;
  registeredEmails: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActualProduct = {
  __typename?: 'ActualProduct';
  id: Scalars['String'];
};

export type AddGiftToCart = {
  __typename?: 'AddGiftToCart';
  itemId: Scalars['Float'];
};

export type AddProductResponse = {
  __typename?: 'AddProductResponse';
  productAddResponse: Maybe<CartProducts>;
  serviceAddResponse: Maybe<Array<Maybe<CartServiceAddResponse>>>;
};

export type AddProductsResponse = {
  __typename?: 'AddProductsResponse';
  productAddResponse: Maybe<Array<Maybe<CartProducts>>>;
  serviceAddResponse: Maybe<Array<Maybe<CartServiceAddResponse>>>;
};

export type AddToCartTryItFirstResult = {
  __typename?: 'AddToCartTryItFirstResult';
  status: Maybe<Array<CartProductStatus>>;
};

export type AlternateSite = {
  __typename?: 'AlternateSite';
  culture: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
};

export type AppConfig = {
  __typename?: 'AppConfig';
  captcha: CaptchaConfig;
  /** @deprecated Use captcha field instead */
  recaptchaSiteKey: Scalars['String'];
  shops: Maybe<Array<Shop>>;
  supportedLocales: Maybe<Array<Scalars['String']>>;
  supportedShops: Maybe<Array<Scalars['String']>>;
};

export type Article = {
  __typename?: 'Article';
  author: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ArticlesQueryResponse = {
  __typename?: 'ArticlesQueryResponse';
  articles: Array<BlogArticle>;
  totalCount: Scalars['Int'];
};

export type ArticlesQueryVariables = {
  brandId?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<Array<Scalars['Int']>>;
  kinds?: InputMaybe<Array<Scalars['Int']>>;
  masterProductCode?: InputMaybe<Scalars['String']>;
  navigationValues?: InputMaybe<Array<Scalars['Int']>>;
  productCodes?: InputMaybe<Array<Scalars['String']>>;
  subCategories?: InputMaybe<Array<Scalars['Int']>>;
  types?: InputMaybe<Array<Scalars['Int']>>;
  /** @deprecated Always set to true now */
  useNewEndpoint?: InputMaybe<Scalars['Boolean']>;
};

export enum AuthorType {
  Motivated = 'Motivated',
  Partner = 'Partner',
  Unknown = 'Unknown',
  Verified = 'Verified',
  VerifiedPartner = 'VerifiedPartner',
}

export type Availability = {
  __typename?: 'Availability';
  availablePickUpStores: Scalars['Int'];
  maxOrderQuantity: Scalars['Int'];
  state: AvailabilityState;
  stockAvailability: StockAvailability;
};

export enum AvailabilityState {
  CanBeBought = 'CanBeBought',
  Disabled = 'Disabled',
  ShowWatchdog = 'ShowWatchdog',
}

export type Benefit = {
  __typename?: 'Benefit';
  iconId: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Benefits = {
  __typename?: 'Benefits';
  vouchers: Array<VoucherDto>;
};

export type BlogArticle = {
  __typename?: 'BlogArticle';
  hreflangId: Maybe<Scalars['String']>;
  image: Maybe<BlogArticleImage>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BlogArticleImage = {
  __typename?: 'BlogArticleImage';
  alt: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Brand = {
  __typename?: 'Brand';
  contactAddress: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoUrl: Maybe<Scalars['String']>;
  manufacturer: Maybe<Scalars['String']>;
  market: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postalAddress: Maybe<Scalars['String']>;
  producer: Maybe<BrandProducer>;
  url: Maybe<Scalars['String']>;
};

export type BrandItem = {
  __typename?: 'BrandItem';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BrandProducer = {
  __typename?: 'BrandProducer';
  postalAddress: Maybe<Scalars['String']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  link: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignId: Maybe<Scalars['String']>;
  detailPageText: Maybe<Scalars['String']>;
  displayOnDetailPage: Maybe<Scalars['Boolean']>;
  giftImageUrl: Maybe<Scalars['String']>;
  giftType: Maybe<GiftType>;
  id: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type CampaignConfig = {
  __typename?: 'CampaignConfig';
  allowed: Maybe<EGiftPackagingAllowedType>;
  groupName: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
};

export type CancelWatchdogsResponse = {
  __typename?: 'CancelWatchdogsResponse';
  cancelledWatchdogCount: Maybe<Scalars['Int']>;
};

export type CaptchaConfig = {
  __typename?: 'CaptchaConfig';
  turnstileSiteKey: Maybe<Scalars['String']>;
};

export type CartAddedService = {
  __typename?: 'CartAddedService';
  productId: Maybe<Scalars['String']>;
  type: Maybe<CartServiceType>;
  value: Maybe<Scalars['String']>;
};

export type CartContent = {
  __typename?: 'CartContent';
  benefits: Benefits;
  cartId: Scalars['String'];
  delivery: Maybe<CartContentProduct>;
  discounts: Array<DiscountDto>;
  payment: Maybe<CartContentProduct>;
  pricesSummary: PricesSummaryDto;
  products: Maybe<Array<Maybe<CartContentProduct>>>;
  serviceItems: ServiceItemsDto;
  vouchers: Array<VoucherDto>;
};

export type CartContentProduct = {
  __typename?: 'CartContentProduct';
  action: Scalars['Boolean'];
  autoInserted: Scalars['Boolean'];
  brandId: Scalars['Int'];
  categoryId: Scalars['Int'];
  count: Scalars['Int'];
  deleted: Scalars['Boolean'];
  discount: Scalars['Boolean'];
  engraving: Maybe<CustomServiceDto>;
  freeProduct: Scalars['Boolean'];
  giftCampaignId: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  isNiche: Scalars['Boolean'];
  isService: Scalars['Boolean'];
  isVirtualService: Scalars['Boolean'];
  itemId: Scalars['Float'];
  priceSumWithVat: Scalars['Int'];
  priceWithVat: Scalars['Int'];
  productCode: Scalars['String'];
  productElisId: Scalars['Int'];
  productId: Scalars['Int'];
  tryItFirstId: Scalars['Float'];
  upselling: Scalars['Boolean'];
  usedProduct: Scalars['Boolean'];
  vat: Scalars['Int'];
};

export type CartItemDto = {
  __typename?: 'CartItemDto';
  action: Maybe<Scalars['Boolean']>;
  autoInserted: Maybe<Scalars['Boolean']>;
  count: Maybe<Scalars['Int']>;
  customServices: Maybe<CartItemDto_CustomServices>;
  deleleted: Maybe<Scalars['Boolean']>;
  discount: Maybe<Scalars['Boolean']>;
  freeProduct: Maybe<Scalars['Boolean']>;
  giftCampaignId: Maybe<Scalars['Int']>;
  ident: Maybe<Scalars['String']>;
  isService: Maybe<Scalars['Boolean']>;
  itemId: Maybe<Scalars['Float']>;
  priceSumWithVat: Maybe<Scalars['Float']>;
  priceWithVat: Maybe<Scalars['Float']>;
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  upselling: Maybe<Scalars['Boolean']>;
  usedProduct: Maybe<Scalars['Boolean']>;
  vat: Maybe<Scalars['Float']>;
};

export type CartItemDto_CustomServices = {
  __typename?: 'CartItemDto_customServices';
  /** default field */
  success: Maybe<Scalars['String']>;
};

export type CartProduct = {
  __typename?: 'CartProduct';
  comparisonPrice: Maybe<Scalars['Boolean']>;
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  isUpselling: Maybe<Scalars['Boolean']>;
  product: Maybe<VpProduct>;
  status: Array<Maybe<CartProductStatus>>;
};

export enum CartProductStatus {
  Default = 'Default',
  Error = 'Error',
  NoCreateCart = 'NoCreateCart',
  OutOfPriceLimit = 'OutOfPriceLimit',
  ReducedCount = 'ReducedCount',
  ShowSoldOutWarning = 'ShowSoldOutWarning',
  Sold = 'Sold',
  Success = 'Success',
  UseProductInCart = 'UseProductInCart',
  VoucherOnline = 'VoucherOnline',
}

export type CartProducts = {
  __typename?: 'CartProducts';
  cart: CartContent;
  itemId: Scalars['Float'];
  messages: Array<Scalars['String']>;
  productId: Scalars['Int'];
  productIncrease: Scalars['Int'];
};

export type CartServiceAddResponse = {
  __typename?: 'CartServiceAddResponse';
  message: Maybe<Scalars['String']>;
  service: Maybe<CartAddedService>;
  status: Array<Maybe<CartProductStatus>>;
};

export type CartServiceInput = {
  count?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  type: CartServiceType;
  value: Scalars['String'];
};

export enum CartServiceType {
  Engraving = 'Engraving',
}

export enum CartStatusType {
  Default = 'Default',
  Error = 'Error',
  InternalError = 'InternalError',
  NotFound = 'NotFound',
  Success = 'Success',
  Warning = 'Warning',
}

export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  alternateSites: Maybe<Array<Maybe<AlternateSite>>>;
  annotation: Maybe<Scalars['String']>;
  brand: Maybe<Brand>;
  breadcrumb: Maybe<Array<Breadcrumb>>;
  campaigns: Maybe<Array<Maybe<Campaign>>>;
  catalogMasterId: Scalars['ID'];
  categorization: Categorization;
  category: Maybe<Array<Maybe<Scalars['String']>>>;
  collection: Maybe<Scalars['String']>;
  config: ProductConfig;
  deliveries: Array<ProductDelivery>;
  description: Maybe<Scalars['String']>;
  descriptionType: Maybe<Scalars['String']>;
  features: ProductDetailFeatures;
  gender: Maybe<Gender>;
  isForbiddenToDisplay: Maybe<Scalars['Boolean']>;
  isPerfume: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  masterProductCode: Scalars['String'];
  primaryCategories: Maybe<PrimaryCategoryObject>;
  related: Array<Scalars['Int']>;
  reviewOverview: Maybe<ReviewOverview>;
  reviewSummary: Maybe<ReviewSummary>;
  subCategory: Maybe<Array<Maybe<Scalars['String']>>>;
  subName: Maybe<Scalars['String']>;
  type: Maybe<Array<Maybe<Scalars['String']>>>;
  url: Scalars['String'];
  variantDisplayType: Maybe<VariantDisplayType>;
  variantGrouppingType: Maybe<VariantGrouppingType>;
  variants: Array<CatalogVariant>;
  webMasterId: Scalars['ID'];
};

export type CatalogProductReviewOverviewArgs = {
  ignoreExternalRating?: InputMaybe<Scalars['Boolean']>;
};

export type CatalogProductVariantCoreInfo = {
  availability: Maybe<Availability>;
  catalogId: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  productCode: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  webId: Maybe<Scalars['ID']>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type CatalogVariant = CatalogProductVariantCoreInfo & {
  __typename?: 'CatalogVariant';
  additionalInfo: Scalars['String'];
  additionalText: Maybe<Scalars['String']>;
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  availability: Availability;
  brand: Maybe<Brand>;
  campaignConfig: Maybe<CampaignConfig>;
  catalogId: Scalars['ID'];
  characteristics: Array<Characteristic>;
  colors: Maybe<Array<Maybe<Scalars['String']>>>;
  descriptionOverride: Maybe<Scalars['String']>;
  documentation: Maybe<ProductDocumentation>;
  eanCode: Scalars['String'];
  features: Maybe<VariantFeatures>;
  gender: Maybe<Gender>;
  media: Maybe<VariantMedia>;
  metaData: Seo;
  name: Maybe<Scalars['String']>;
  navigationValues: Array<Scalars['Int']>;
  orderCode: Maybe<Scalars['String']>;
  originalPrice: Maybe<OriginalPrice>;
  parameters: Maybe<Parameters>;
  price: Price;
  primaryCategories: Maybe<PrimaryCategoryObject>;
  productCode: Scalars['String'];
  recentMinPrice: Maybe<RecentMinPrice>;
  stockAvailability: StockInfo;
  unitPrice: Maybe<UnitPriceDetail>;
  url: Scalars['String'];
  variantName: Maybe<Scalars['String']>;
  variantType: Maybe<Scalars['String']>;
  webId: Scalars['ID'];
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type Categorization = {
  __typename?: 'Categorization';
  categories: Maybe<Array<CategorizationItem>>;
  kinds: Maybe<Array<CategorizationItem>>;
  subCategories: Maybe<Array<CategorizationItem>>;
  types: Maybe<Array<CategorizationItem>>;
};

export type CategorizationItem = {
  __typename?: 'CategorizationItem';
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  primary: Maybe<Scalars['Boolean']>;
};

export type CategorizationKind = {
  name: Scalars['String'];
};

export type Characteristic = {
  __typename?: 'Characteristic';
  group: Maybe<Scalars['String']>;
  help: Maybe<Scalars['String']>;
  /** @deprecated Not supported by server. */
  link: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClickAndCollectStore = {
  __typename?: 'ClickAndCollectStore';
  code: Scalars['String'];
  description: Scalars['String'];
  earliestPickup: Scalars['String'];
  isOverloaded: Maybe<Scalars['Boolean']>;
  location: Location;
  name: Scalars['String'];
  stockCount: StockAvailability;
};

export type ClientCache = {
  __typename?: 'ClientCache';
  hasWebcam: Maybe<Scalars['Boolean']>;
};

export type ClientHeaders = {
  __typename?: 'ClientHeaders';
  abTest: Maybe<Scalars['String']>;
  assetsPath: Scalars['String'];
  authorization: Scalars['String'];
  featureFlags: FeatureFlags;
  features: Scalars['String'];
  gatewayUrl: Scalars['String'];
  groupId: Scalars['String'];
  hairAnalyzer: HairAnalyzer;
  isGatewayRouterProxyEnabled: Scalars['Boolean'];
  isPrimaryCurrencyFirst: Maybe<Scalars['Boolean']>;
  lastVisitedProducts: Maybe<Array<Scalars['String']>>;
  modifaceDomain: Maybe<Scalars['String']>;
  mount: Scalars['String'];
  newRelicAccountId: Maybe<Scalars['String']>;
  newRelicAppId: Maybe<Scalars['String']>;
  newRelicBrowserKey: Maybe<Scalars['String']>;
  newRelicEnvironment: Maybe<Scalars['String']>;
  originUrl: Maybe<Scalars['String']>;
  role: Scalars['String'];
  secondaryCurrency: Maybe<SecondaryCurrency>;
  shadefinderAppId: Maybe<Scalars['String']>;
  shopId: Scalars['String'];
  skinAnalyzer: SkinAnalyzer;
  traffic: Maybe<Scalars['String']>;
  userEmail: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userName: Maybe<Scalars['String']>;
  xAbTest: Maybe<Scalars['String']>;
  xLangTag: Maybe<Scalars['String']>;
  xUserToken: Maybe<Scalars['String']>;
};

export type ClientProductSsr = {
  __typename?: 'ClientProductSsr';
  id: Maybe<Scalars['String']>;
  pathname: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type ClientWatchdog = {
  __typename?: 'ClientWatchdog';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  success: Scalars['String'];
};

export type ClientWatchdogs = {
  __typename?: 'ClientWatchdogs';
  list: Array<Maybe<ClientWatchdog>>;
};

export type Cloudflare = {
  __typename?: 'Cloudflare';
  baseUrl: Scalars['String'];
  enabled: Scalars['Boolean'];
  quality: Scalars['Int'];
};

export type CompositionTables = {
  __typename?: 'CompositionTables';
  nutritionValues: Maybe<Array<NutritionValue>>;
  vitaminsAndMinerals: Maybe<Array<VitaminsAndMinerals>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  code: Scalars['String'];
  combinableWithCustomerBenefits: Scalars['Boolean'];
  id: Scalars['Int'];
  insertedBy: Scalars['String'];
  rank: Scalars['Int'];
  typeId: Scalars['Int'];
  validationErrors: Array<CouponValidationErrors>;
};

export type CouponMinLevels = {
  __typename?: 'CouponMinLevels';
  missing: Scalars['Int'];
  threshold: Scalars['Int'];
  type: Scalars['String'];
};

export type CouponValidationErrors = {
  __typename?: 'CouponValidationErrors';
  minLevels: Maybe<Array<CouponMinLevels>>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  symbol: Maybe<Scalars['String']>;
};

export type CustomServiceDto = {
  __typename?: 'CustomServiceDto';
  cartItemId: Scalars['Int'];
  cartServiceItem: Scalars['Int'];
  priceWithVat: Scalars['Int'];
  value: Scalars['String'];
};

export type DefaultCurrency = {
  __typename?: 'DefaultCurrency';
  code: Scalars['String'];
  currencyId: Maybe<Scalars['Int']>;
  symbol: Maybe<Scalars['String']>;
};

export type Delivery = {
  __typename?: 'Delivery';
  date: Maybe<Scalars['String']>;
  dateFrom: Maybe<Scalars['String']>;
  dateTo: Maybe<Scalars['String']>;
  disallowedReason: Maybe<Scalars['String']>;
  isAirTransport: Maybe<Scalars['Boolean']>;
  isPersonal: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
};

export enum DeliveryDisallowedReason {
  AirTransportDisallowed = 'AirTransportDisallowed',
}

export enum DeliveryType {
  AirTransport = 'AirTransport',
  Personal = 'Personal',
  Transport = 'Transport',
}

export type DesiredShade = {
  __typename?: 'DesiredShade';
  darker: Maybe<RecommendedProduct>;
  ideal: Maybe<RecommendedProduct>;
  lighter: Maybe<RecommendedProduct>;
};

export type DiscountDto = {
  __typename?: 'DiscountDto';
  priority: Scalars['Int'];
  type: EDiscountType;
  value: Scalars['Int'];
};

export enum EDiscountType {
  AbsoluteWithVat = 'AbsoluteWithVat',
  AbsoluteWithoutVat = 'AbsoluteWithoutVat',
  Percentage = 'Percentage',
}

export enum EGiftPackagingAllowedType {
  Brand = 'Brand',
  None = 'None',
  Product = 'Product',
}

export enum EStatus {
  Default = 'Default',
  Error = 'Error',
  Fail = 'Fail',
  NoCreateCart = 'NoCreateCart',
  NotFoundProduct = 'NotFoundProduct',
  OutOfLimit = 'OutOfLimit',
  OutOfPriceLimit = 'OutOfPriceLimit',
  ReducedCount = 'ReducedCount',
  Sold = 'Sold',
  Success = 'Success',
  UseProductInCart = 'UseProductInCart',
  VoucherAndProductNotAllowed = 'VoucherAndProductNotAllowed',
  Warning = 'Warning',
}

export type EmailAddressList = {
  __typename?: 'EmailAddressList';
  complaintAddress: Maybe<Scalars['String']>;
  infoAddress: Maybe<Scalars['String']>;
};

export type Engraving = {
  __typename?: 'Engraving';
  allowed: Scalars['Boolean'];
  characterCount: Scalars['Int'];
  config: EngravingConfig;
  image: Maybe<Scalars['String']>;
  productId: Scalars['Int'];
};

export type EngravingConfig = {
  __typename?: 'EngravingConfig';
  isActive: Maybe<Scalars['Boolean']>;
  isAvailable: Scalars['Boolean'];
  limit: Maybe<Scalars['Int']>;
  orderedCount: Maybe<Scalars['Int']>;
  price: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['String']>;
  servicesType: Maybe<Scalars['String']>;
};

export type EventCalendar = {
  __typename?: 'EventCalendar';
  activeFrom: Maybe<Scalars['String']>;
  activeTo: Maybe<Scalars['String']>;
  backgroundImageUrl: Maybe<Scalars['String']>;
  calendarsCollectionId: Maybe<Scalars['Int']>;
  foregroundImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  items: Maybe<Array<Maybe<EventCalendarDay>>>;
  shopId: Maybe<Scalars['String']>;
  tileBackgroundColor: Maybe<Scalars['String']>;
  tileBorderColor: Maybe<Scalars['String']>;
  tileNumberColor: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColor: Maybe<Scalars['String']>;
  type: Maybe<EventCalendarType>;
};

export type EventCalendarDay = {
  __typename?: 'EventCalendarDay';
  /** @deprecated Use 'brands' instead */
  brand: Maybe<Brand>;
  brands: Maybe<Array<Maybe<Brand>>>;
  buttonText: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  discount: Maybe<Scalars['Boolean']>;
  filterId: Maybe<Array<Maybe<Scalars['Int']>>>;
  filterType: Maybe<Scalars['String']>;
  freeDelivery: Maybe<Scalars['Boolean']>;
  giftAvailable: Maybe<Scalars['Boolean']>;
  largeImage: Maybe<Scalars['String']>;
  smallImage: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  todayItem: Maybe<Scalars['Boolean']>;
  url: Maybe<Scalars['String']>;
  voucher: Maybe<Scalars['String']>;
};

export enum EventCalendarType {
  Advent = 'Advent',
  FlashSale = 'FlashSale',
}

export enum ExperimentMoodPhotosVariant {
  AllMood = 'all_mood',
  AllMoodExceptFirst = 'all_mood_except_first',
  Default = 'default',
}

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  discovery_box_self_choice_enabled: Maybe<Scalars['Boolean']>;
  dual_currency_price: Maybe<Scalars['Boolean']>;
  experiment_pd_action_percentage_from_rrp: Maybe<Scalars['Boolean']>;
  experiment_pd_bloomreach_tracking_recommendations: Maybe<Scalars['Boolean']>;
  experiment_pd_discount_from_rrp_hidden: Maybe<Scalars['Boolean']>;
  experiment_pd_loyalty_gift: Maybe<Scalars['Boolean']>;
  experiment_pd_mood_photos_variant: Maybe<ExperimentMoodPhotosVariant>;
  experiment_pd_sticky_atc_button: Maybe<Scalars['Boolean']>;
  killswitch_pd_faq: Maybe<Scalars['Boolean']>;
  livestream_on_pd_enabled: Maybe<Scalars['Boolean']>;
  pd_display_rich_content_as_first_tab_by_ids: Maybe<RichContentAsFirstTabFeatureFlag>;
  pd_should_show_dev_tools: Maybe<Scalars['Boolean']>;
  pd_upselling_product_ids_for_testing: Maybe<Array<Scalars['String']>>;
  pd_upselling_unmet_voucher_condition: Maybe<Scalars['Boolean']>;
  reco_product_detail: Maybe<Scalars['Boolean']>;
  reco_product_detail_add_to_cart: Maybe<Scalars['Boolean']>;
  release_pd_criteo_rma: Maybe<Scalars['Boolean']>;
  release_pd_sponsored_ads_products: Maybe<Scalars['Boolean']>;
  shade_finder_try_it_first_product_master_ids: Maybe<Array<Scalars['String']>>;
  strict_sales_display_type: Maybe<StrictSalesDisplayTypeFeatureFlag>;
};

export type FeatureSwitches = {
  __typename?: 'FeatureSwitches';
  addToCartResendDelay: Maybe<Scalars['String']>;
  addToCartWarningCount: Maybe<Scalars['String']>;
  hideReviewsABTest: Maybe<Scalars['String']>;
  modifaceDesktopEnabled: Maybe<Scalars['String']>;
  modifaceMobileEnabled: Maybe<Scalars['String']>;
  reviewsOnServerIds: Maybe<Scalars['String']>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
};

export type Filter = {
  __typename?: 'Filter';
  key: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

export type FilterInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type FilterableWishlist = {
  __typename?: 'FilterableWishlist';
  filtration: Array<WishlistFiltration>;
  id: Scalars['ID'];
  listing: WishlistListing;
  missingProductIds: Array<Scalars['Int']>;
};

export type Flag = {
  __typename?: 'Flag';
  countryCode: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Footer = {
  __typename?: 'Footer';
  benefits: Maybe<Array<Maybe<Benefit>>>;
  copyrightText: Maybe<Scalars['String']>;
  flags: Maybe<Array<Maybe<Flag>>>;
  footerText: Maybe<FooterText>;
  linksSections: Maybe<Array<Maybe<LinkSection>>>;
  partners: Maybe<Array<Maybe<Partner>>>;
  payments: Maybe<Array<Maybe<Payment>>>;
  places: Maybe<Array<Maybe<Place>>>;
  quickContact: Maybe<QuickContact>;
  socialIcons: Maybe<Array<Maybe<SocialIcon>>>;
};

export type FooterText = {
  __typename?: 'FooterText';
  homePage: Maybe<HomePageFooter>;
};

export type Freetext = {
  __typename?: 'Freetext';
  content: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type GdprSettings = {
  __typename?: 'GdprSettings';
  securityAndPrivacyUrl: Maybe<Scalars['String']>;
  termsAndConditionsUrl: Maybe<Scalars['String']>;
};

export enum Gender {
  Man = 'man',
  Unisex = 'unisex',
  Woman = 'woman',
}

export type GenericModifaceEffect = {
  __typename?: 'GenericModifaceEffect';
  category: Maybe<Scalars['String']>;
  shades: Maybe<Scalars['JSON']>;
  upc: Maybe<Scalars['String']>;
};

export type GetLivestreamResponse = {
  __typename?: 'GetLivestreamResponse';
  shows: Maybe<Array<Livestream>>;
};

export type GetLivestreamVariables = {
  productCode: Scalars['String'];
};

export type GiftAddDtoInput = {
  campaignId?: InputMaybe<Scalars['Int']>;
  count: Scalars['Int'];
  productId: Scalars['Int'];
};

export type GiftModel = {
  __typename?: 'GiftModel';
  code: Scalars['String'];
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  idAction: Maybe<Scalars['Int']>;
  productId: Maybe<Scalars['Int']>;
};

export type GiftPackagingConfig = {
  __typename?: 'GiftPackagingConfig';
  allowed: Maybe<EGiftPackagingAllowedType>;
  price: Maybe<Scalars['Float']>;
};

export enum GiftType {
  Basic = 'BASIC',
  Gwp = 'GWP',
  Loyalty = 'LOYALTY',
  Sample = 'SAMPLE',
  Special = 'SPECIAL',
  TryItFirst = 'TRY_IT_FIRST',
}

export type HairAnalyzer = {
  __typename?: 'HairAnalyzer';
  apiUrl: Scalars['String'];
  env: Scalars['String'];
};

export type HairAnalyzerFeature = {
  __typename?: 'HairAnalyzerFeature';
  banner: Maybe<Scalars['String']>;
  brands: Maybe<Array<Scalars['String']>>;
};

export type HairModifaceEffects = {
  __typename?: 'HairModifaceEffects';
  category: Maybe<Scalars['String']>;
  shades: Maybe<Array<Maybe<ModifaceHairShade>>>;
  upc: Maybe<Scalars['String']>;
};

export type HomePageFooter = {
  __typename?: 'HomePageFooter';
  leftSideHtml: Maybe<Scalars['String']>;
  rightSideHtml: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
};

export type ImagesByCategory = {
  __typename?: 'ImagesByCategory';
  mainImage: Image;
  others: Maybe<Array<Maybe<Image>>>;
  previewImage: Maybe<Image>;
  shadeImage: Maybe<Image>;
};

export type InactiveWatchdogsResponse = {
  __typename?: 'InactiveWatchdogsResponse';
  cursor: Maybe<Scalars['Int']>;
  moreAvailable: Maybe<Scalars['Boolean']>;
  watchdogs: Maybe<Array<Maybe<InctiveWatchdogsResponse_Watchdog>>>;
};

export type InctiveWatchdogsResponse_Watchdog = {
  __typename?: 'InctiveWatchdogsResponse_Watchdog';
  catalogId: Maybe<Scalars['Int']>;
};

export type InstructionDocument = {
  __typename?: 'InstructionDocument';
  type: InstructionDocumentType;
  url: Scalars['String'];
};

export enum InstructionDocumentType {
  InstructionsForUse = 'InstructionsForUse',
  PackagingInformation = 'PackagingInformation',
}

export type InvalidCoupons = {
  __typename?: 'InvalidCoupons';
  coupons: Maybe<Array<Coupon>>;
};

export type ItemInCart = {
  __typename?: 'ItemInCart';
  cartItemId: Scalars['Int'];
  count: Maybe<Scalars['Int']>;
  price: Maybe<Scalars['Int']>;
  productId: Maybe<Scalars['Int']>;
  warning: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ItemResponse = {
  __typename?: 'ItemResponse';
  itemId: Maybe<Scalars['Float']>;
};

export type Language = {
  __typename?: 'Language';
  htmlLangCode: Maybe<Scalars['String']>;
  langId: Maybe<Scalars['Int']>;
  priceDecimalPlaces: Maybe<Scalars['Int']>;
  priceFormat: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type LanguagedMessage = {
  __typename?: 'LanguagedMessage';
  acceptLanguage: Scalars['String'];
  messages: Maybe<Scalars['JSON']>;
};

export type LegalInformation = {
  __typename?: 'LegalInformation';
  compositionTables: Maybe<CompositionTables>;
  document: Maybe<Scalars['String']>;
  foodComposition: Maybe<Scalars['String']>;
  importantNotice: Maybe<Scalars['String']>;
  ingredients: Maybe<Scalars['String']>;
  instructionDocument: Maybe<InstructionDocument>;
  instructions: Maybe<Scalars['String']>;
  isSensitiveHairProduct: Maybe<Scalars['Boolean']>;
  manufacturerImporter: Maybe<Scalars['String']>;
  nutritionValues: Maybe<Scalars['String']>;
  preparationUsage: Maybe<Scalars['String']>;
  specialStorage: Maybe<Scalars['String']>;
  video: Maybe<Scalars['String']>;
  warnings: Maybe<Scalars['String']>;
};

export type Link = {
  __typename?: 'Link';
  targetUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type LinkSection = {
  __typename?: 'LinkSection';
  links: Maybe<Array<Maybe<Link>>>;
  sectionType: Maybe<SectionType>;
};

export type Livestream = {
  __typename?: 'Livestream';
  deeplink: Scalars['String'];
  description: Scalars['String'];
  isLive: Scalars['Boolean'];
  previewImageUrl: Maybe<Scalars['String']>;
  publishedDate: Maybe<Scalars['String']>;
  scheduledDate: Scalars['String'];
  scheduledStart: Maybe<Scalars['String']>;
  showId: Scalars['String'];
  title: Scalars['String'];
  videoLength: Scalars['String'];
};

export type Locale = {
  __typename?: 'Locale';
  currency: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  priceDecimalPlaces: Maybe<Scalars['Int']>;
  priceFormat: Maybe<Scalars['String']>;
  tag: Maybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['String'];
  longitude: Scalars['String'];
};

export type LoggedInUserReview = {
  __typename?: 'LoggedInUserReview';
  digests: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  images: Maybe<Array<LoggedInUserReviewImages>>;
  ipAddress: Maybe<Scalars['String']>;
  masterProductCode: Scalars['String'];
  name: Scalars['String'];
  ratings: Maybe<Array<ReviewRating>>;
  score: Scalars['Int'];
  source: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variantId: Maybe<Scalars['Int']>;
};

export type LoggedInUserReviewImages = {
  __typename?: 'LoggedInUserReviewImages';
  id: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type LoyaltyState = {
  __typename?: 'LoyaltyState';
  state: Maybe<LoyaltyStateEnum>;
};

export enum LoyaltyStateEnum {
  Active = 'Active',
  Enrolling = 'Enrolling',
  Inactive = 'Inactive',
  Leaving = 'Leaving',
}

export type MasterProductListItem = {
  __typename?: 'MasterProductListItem';
  annotation: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  masterId: Maybe<Scalars['Int']>;
  masterProductCode: Maybe<Scalars['String']>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview. */
  reviewSummary: Maybe<ReviewSummary>;
  subName: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  variants: Array<Maybe<ProductListItem>>;
};

export type ModifaceEffect = {
  __typename?: 'ModifaceEffect';
  category: Maybe<Scalars['String']>;
  shades: Maybe<Array<Maybe<ModifaceEffectShade>>>;
  upc: Maybe<Scalars['String']>;
};

export type ModifaceEffectShade = {
  __typename?: 'ModifaceEffectShade';
  color_a: Maybe<Scalars['Int']>;
  color_b: Maybe<Scalars['Int']>;
  color_g: Maybe<Scalars['Int']>;
  color_r: Maybe<Scalars['Int']>;
  contrastBoost: Maybe<Scalars['Float']>;
  gamma: Maybe<Scalars['Float']>;
  glossDetail: Maybe<Scalars['Float']>;
  intensity: Maybe<Scalars['Float']>;
  placement: Maybe<Scalars['String']>;
  skinClearing: Maybe<Scalars['Float']>;
  skinGlow: Maybe<Scalars['Float']>;
  sparkle_a: Maybe<Scalars['Float']>;
  sparkle_b: Maybe<Scalars['Int']>;
  sparkle_g: Maybe<Scalars['Int']>;
  sparkle_r: Maybe<Scalars['Int']>;
  wetness: Maybe<Scalars['Float']>;
};

export type ModifaceHairShade = {
  __typename?: 'ModifaceHairShade';
  blendGradientBottomOffset: Maybe<Scalars['Int']>;
  blendGradientTopOffset: Maybe<Scalars['Int']>;
  effect: Maybe<Scalars['Int']>;
  enableRootRecoloring: Maybe<Scalars['Boolean']>;
  family: Maybe<Scalars['String']>;
  histogram_b: Maybe<Scalars['String']>;
  histogram_c: Maybe<Scalars['String']>;
  histogram_g: Maybe<Scalars['String']>;
  histogram_r: Maybe<Scalars['String']>;
  intensity: Maybe<Scalars['Float']>;
  renderingVersion: Maybe<Scalars['Int']>;
  shazamColorFamily: Maybe<Scalars['String']>;
  shine: Maybe<Scalars['Float']>;
  totalpixels: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddGiftToCart: Maybe<ItemResponse>;
  AddProductToCart: AddProductResponse;
  AddProductsToCart: AddProductsResponse;
  DeleteGiftFromCart: Maybe<Scalars['String']>;
  DeleteProductFromCart: Maybe<ShoppingCartModel>;
  TryItFirstAddToCart: AddToCartTryItFirstResult;
  WishlistAddProduct: Maybe<Wishlist>;
  WishlistAddProductByOwner: Maybe<Wishlist>;
  WishlistCopyWishlist: Maybe<WishlistId>;
  WishlistCreateList: Maybe<WishlistList>;
  WishlistDeleteList: Maybe<Scalars['Boolean']>;
  WishlistMergeWishlists: Maybe<Wishlist>;
  WishlistMutateLists: Maybe<WishlistLists>;
  WishlistRemoveProduct: Maybe<Wishlist>;
  WishlistRemoveProductByOwner: Maybe<Wishlist>;
  WishlistShareList: Maybe<WishlistShareListResponse>;
  WishlistUpdateList: Maybe<Scalars['Boolean']>;
  addProductToClickAndCollect: Maybe<ShoppingCartModel>;
  addReview: Maybe<ReviewResponse>;
  cancelWatchdogs: Maybe<CancelWatchdogsResponse>;
  createWatchdog: WatchDog;
  dummy: Maybe<Scalars['String']>;
  handleVote: Maybe<Review>;
  registerCustomerForLoyaltyProgram: Maybe<Scalars['Boolean']>;
  reportSponsoredAdsProductClick: Maybe<Scalars['Boolean']>;
  reportSponsoredAdsProductImpression: Maybe<Scalars['Boolean']>;
  saveShadefinderUserData: Maybe<SaveShadefinderUserDataResult>;
  /** @deprecated Use createWatchdog. Send catalogId instead of productId */
  sendWatchdog: WatchDog;
  setActualProduct: Maybe<ActualProduct>;
  storeWatchdog: Maybe<Array<Maybe<ClientWatchdog>>>;
  uploadReviewImages: Maybe<ReviewImageUploadResponse>;
};

export type MutationAddGiftToCartArgs = {
  gift: GiftAddDtoInput;
};

export type MutationAddProductToCartArgs = {
  product: ProductToCartInput;
  services?: InputMaybe<Array<InputMaybe<CartServiceInput>>>;
};

export type MutationAddProductsToCartArgs = {
  products: Array<ProductToCartInput>;
  services?: InputMaybe<Array<InputMaybe<CartServiceInput>>>;
};

export type MutationDeleteGiftFromCartArgs = {
  itemId: Scalars['Float'];
};

export type MutationDeleteProductFromCartArgs = {
  itemId: Scalars['Float'];
};

export type MutationTryItFirstAddToCartArgs = {
  productCode: Scalars['String'];
  productId: Scalars['String'];
  tryItFirstId: Scalars['String'];
};

export type MutationWishlistAddProductArgs = {
  product: Scalars['String'];
};

export type MutationWishlistAddProductByOwnerArgs = {
  owner: Scalars['String'];
  product: Scalars['String'];
};

export type MutationWishlistCopyWishlistArgs = {
  anonymousId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
};

export type MutationWishlistCreateListArgs = {
  name: Scalars['String'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MutationWishlistDeleteListArgs = {
  id: Scalars['String'];
};

export type MutationWishlistMergeWishlistsArgs = {
  newOwner: Scalars['String'];
  owner: Scalars['String'];
};

export type MutationWishlistMutateListsArgs = {
  addToList: Array<Scalars['String']>;
  productIds: Array<Scalars['String']>;
  removeFromList: Array<Scalars['String']>;
};

export type MutationWishlistRemoveProductArgs = {
  product: Scalars['String'];
};

export type MutationWishlistRemoveProductByOwnerArgs = {
  owner: Scalars['String'];
  product: Scalars['String'];
};

export type MutationWishlistShareListArgs = {
  id: Scalars['String'];
  sharedListId?: InputMaybe<Scalars['String']>;
};

export type MutationWishlistUpdateListArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MutationAddProductToClickAndCollectArgs = {
  productId: Scalars['Int'];
  warehouseCode: Scalars['String'];
};

export type MutationAddReviewArgs = {
  captchaToken?: InputMaybe<Scalars['String']>;
  digests?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']>>;
  expectedImageCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  masterProductCode: Scalars['String'];
  name: Scalars['String'];
  ratings?: InputMaybe<Array<InputMaybe<Rating>>>;
  score: Scalars['Int'];
  source: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['Int']>;
};

export type MutationCancelWatchdogsArgs = {
  catalogId: Scalars['Int'];
  emails: Array<Scalars['String']>;
};

export type MutationCreateWatchdogArgs = {
  catalogId: Scalars['Int'];
  email: Scalars['String'];
};

export type MutationHandleVoteArgs = {
  action: VoteAction;
  id: Scalars['String'];
  type: VoteType;
};

export type MutationReportSponsoredAdsProductClickArgs = {
  campaignId: Scalars['String'];
  url: Scalars['String'];
};

export type MutationReportSponsoredAdsProductImpressionArgs = {
  campaignId: Scalars['String'];
  url: Scalars['String'];
};

export type MutationSaveShadefinderUserDataArgs = {
  userData: ShadefinderUserDataInput;
};

export type MutationSendWatchdogArgs = {
  email: Scalars['String'];
  productId: Scalars['String'];
};

export type MutationSetActualProductArgs = {
  id: Scalars['String'];
};

export type MutationStoreWatchdogArgs = {
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MutationUploadReviewImagesArgs = {
  images: Array<Scalars['Upload']>;
  reviewId: Scalars['Int'];
};

export type NutritionValue = {
  __typename?: 'NutritionValue';
  amount: Maybe<Scalars['Float']>;
  amountSign: Maybe<Scalars['String']>;
  measureUnit: Maybe<Scalars['String']>;
  nutritionValue: Maybe<Scalars['String']>;
  variantAmount: Maybe<Scalars['Float']>;
};

export type OrderCoupons = {
  __typename?: 'OrderCoupons';
  code: Maybe<Scalars['String']>;
  invalidCoupons: Maybe<InvalidCoupons>;
};

export type OrderCouponsInput = {
  orderSourceType: Scalars['String'];
  priceDecimalPlaces: Scalars['Int'];
  voucherCode: Scalars['String'];
};

export type OriginalPrice = {
  __typename?: 'OriginalPrice';
  currency: Maybe<Scalars['String']>;
  tax: Maybe<Scalars['Float']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type Pager = {
  __typename?: 'Pager';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  remaining: Scalars['Int'];
};

export type PagerInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type Parameters = {
  __typename?: 'Parameters';
  amount: Maybe<Scalars['Float']>;
  package: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  externalCode: Maybe<Scalars['String']>;
  imagePath: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  onlyOnHomepage: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
  type: Maybe<PartnerType>;
};

export enum PartnerType {
  External = 'External',
  Internal = 'Internal',
}

export enum PathTemplate {
  Error = 'Error',
  HomePage = 'HomePage',
  NotFound = 'NotFound',
  ProductDetailSimple = 'ProductDetailSimple',
  ReviewsPage = 'ReviewsPage',
  Wishlist = 'Wishlist',
}

export type PathView = {
  __typename?: 'PathView';
  catalogId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  path: Scalars['String'];
  productId: Maybe<Scalars['String']>;
  type: PathTemplate;
};

export type Payment = {
  __typename?: 'Payment';
  imageUrl: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type PdFaqEntry = {
  __typename?: 'PdFaqEntry';
  a: Scalars['String'];
  q: Scalars['String'];
};

export type PerfumerItem = {
  __typename?: 'PerfumerItem';
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type Perfumers = {
  __typename?: 'Perfumers';
  items: Maybe<Array<Maybe<PerfumerItem>>>;
};

export type Place = {
  __typename?: 'Place';
  name: Maybe<Scalars['String']>;
  stores: Maybe<Array<Maybe<Store>>>;
};

export type Price = {
  __typename?: 'Price';
  currency: Maybe<Scalars['String']>;
  tax: Maybe<Scalars['Float']>;
  value: Maybe<Scalars['Float']>;
};

export type PriceLevel = {
  __typename?: 'PriceLevel';
  levels: Maybe<Array<PriceLevelItem>>;
};

export type PriceLevelItem = {
  __typename?: 'PriceLevelItem';
  value: Scalars['Int'];
};

export type PricesSummaryDto = {
  __typename?: 'PricesSummaryDto';
  discountWithoutDelivery: Scalars['Int'];
  priceDelivery: Scalars['Int'];
  priceItemSummary: Scalars['Int'];
  pricePayment: Scalars['Int'];
  priceProductsSummary: Scalars['Int'];
  vat: Scalars['Int'];
};

export type PrimaryCategories = {
  __typename?: 'PrimaryCategories';
  category: Maybe<Scalars['String']>;
  kind: Maybe<Scalars['String']>;
  subCategory: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type PrimaryCategoryObject = {
  __typename?: 'PrimaryCategoryObject';
  category: Maybe<CategorizationItem>;
  kind: Maybe<CategorizationItem>;
  subCategory: Maybe<CategorizationItem>;
  type: Maybe<CategorizationItem>;
};

export type Product = {
  __typename?: 'Product';
  alternateSites: Maybe<Array<Maybe<AlternateSite>>>;
  annotation: Maybe<Scalars['String']>;
  availableSets: Maybe<ProductAvailableSets>;
  /** @deprecated Use brandInfo. */
  brand: Maybe<Scalars['String']>;
  /** @deprecated Use brandInfo. */
  brandId: Maybe<Scalars['Int']>;
  brandInfo: Maybe<Brand>;
  /** @deprecated Use brandInfo. */
  brandRef: Maybe<Brand>;
  breadcrumb: Maybe<Array<Maybe<Breadcrumb>>>;
  campaigns: Maybe<Array<Maybe<Campaign>>>;
  categorization: Categorization;
  category: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Use characteristics of specific variant. */
  characteristics: Maybe<Array<Maybe<Characteristic>>>;
  code: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  composition: Maybe<Array<Maybe<Characteristic>>>;
  config: ProductConfig;
  deliveries: Maybe<Array<Maybe<Delivery>>>;
  description: Maybe<Scalars['String']>;
  hasDifferentColors: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isForbiddenToDisplay: Maybe<Scalars['Boolean']>;
  isPerfume: Maybe<Scalars['Boolean']>;
  isShadeFinderAvailable: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  manufacturer: Maybe<Scalars['String']>;
  marketType: Maybe<Scalars['String']>;
  orderUnit: Maybe<Scalars['String']>;
  primaryCategories: PrimaryCategories;
  /** @deprecated Use reviewOverview. This return always null. */
  rating: Maybe<ProductRating>;
  related: Maybe<Array<Maybe<Product>>>;
  /** @deprecated Use 'getArticles' instead. */
  relatedArticles: Maybe<Array<Maybe<Article>>>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview instead. ReviewOverview is more effective and faster to resolve. */
  reviewSummary: Maybe<ReviewSummary>;
  seo: Maybe<Seo>;
  subCategory: Maybe<Array<Maybe<Scalars['String']>>>;
  subName: Maybe<Scalars['String']>;
  type: Maybe<Array<Maybe<Scalars['String']>>>;
  unit: Maybe<Scalars['String']>;
  /** @deprecated Use perAmount directly inside unitPrice. */
  unitAmount: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  variantDisplayType: Maybe<VariantDisplayType>;
  variants: Maybe<Array<Maybe<Variant>>>;
};

export type ProductAccessories = {
  __typename?: 'ProductAccessories';
  products: Maybe<Array<ProductAccessory>>;
};

export type ProductAccessory = {
  __typename?: 'ProductAccessory';
  catalogId: Maybe<Scalars['Int']>;
};

export type ProductAvailableSet = {
  __typename?: 'ProductAvailableSet';
  catalogId: Maybe<Scalars['Int']>;
  type: Maybe<ProductAvailableSetType>;
  webId: Maybe<Scalars['Int']>;
};

export enum ProductAvailableSetType {
  EconomyPack = 'EconomyPack',
  GiftSet = 'GiftSet',
  TravelSet = 'TravelSet',
  Unknown = 'Unknown',
}

export type ProductAvailableSets = {
  __typename?: 'ProductAvailableSets';
  sets: Maybe<Array<Maybe<ProductAvailableSet>>>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  showAddToCartButton: Maybe<Scalars['Boolean']>;
  showAddToCartModal: Maybe<Scalars['Boolean']>;
};

export type ProductDelivery = {
  __typename?: 'ProductDelivery';
  date: Scalars['String'];
  dateFrom: Maybe<Scalars['String']>;
  dateTo: Maybe<Scalars['String']>;
  delivery: DeliveryType;
  disallowedReason: Maybe<DeliveryDisallowedReason>;
  freeShipping: Maybe<Scalars['Boolean']>;
  icon: Maybe<Scalars['String']>;
  limitedFreeShipping: Maybe<Array<Maybe<Scalars['Int']>>>;
  name: Scalars['String'];
  price: Maybe<Scalars['Float']>;
  thresholdTime: Maybe<Scalars['String']>;
};

export type ProductDetailAdsInput = {
  /**
   * Brands whose contract forbids showing ads on their PDP (Dior). The request is
   * still sent so the provider can refresh availability and keep tracking the user,
   * but it must not return any ads to display.
   */
  excludeFromAds?: InputMaybe<Scalars['Boolean']>;
  masterId: Scalars['Int'];
  products: Array<ProductDetailAdsProductInput>;
};

export type ProductDetailAdsProductInput = {
  id: Scalars['Int'];
  isAvailable: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type ProductDetailFeatures = {
  __typename?: 'ProductDetailFeatures';
  accessories: Maybe<ProductAccessories>;
  availableSets: Maybe<ProductAvailableSets>;
  composition: Maybe<Array<Characteristic>>;
  hairAnalyzer: Maybe<HairAnalyzerFeature>;
  isShadeFinderAvailable: Maybe<Scalars['Boolean']>;
  selfChoiceBox: Maybe<SelfChoiceBox>;
  skinAnalyzer: Maybe<SkinAnalyzerFeature>;
};

export type ProductDocumentation = {
  __typename?: 'ProductDocumentation';
  composition: Maybe<CompositionTables>;
  document: Maybe<InstructionDocument>;
  foodComposition: Maybe<Scalars['String']>;
  importantNotice: Maybe<Scalars['String']>;
  ingredients: Maybe<Scalars['String']>;
  instructions: Maybe<Scalars['String']>;
  manufacturerImporter: Maybe<Scalars['String']>;
  preparationUsage: Maybe<Scalars['String']>;
  specialStorage: Maybe<Scalars['String']>;
  video: Maybe<Video>;
  warnings: Maybe<Scalars['String']>;
};

export enum ProductIdType {
  Catalog = 'Catalog',
  Web = 'Web',
}

export type ProductIdentifiers = {
  __typename?: 'ProductIdentifiers';
  catalogId: Maybe<Scalars['Int']>;
  catalogMasterId: Maybe<Scalars['Int']>;
  webMasterId: Maybe<Scalars['Int']>;
};

export type ProductListItem = {
  __typename?: 'ProductListItem';
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  canBuy: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  images: ImagesByCategory;
  name: Maybe<Scalars['String']>;
  parameters: Maybe<Parameters>;
  price: Maybe<Price>;
  productCode: Maybe<Scalars['String']>;
  showWatchdog: Scalars['Boolean'];
  stockAvailability: Maybe<StockInfo>;
  unitPrice: Maybe<UnitPrice>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  currencyCode: Maybe<Scalars['String']>;
  originalPrice: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['String']>;
  unitPrice: Maybe<Scalars['Float']>;
};

export type ProductRating = {
  __typename?: 'ProductRating';
  score: Maybe<Scalars['Float']>;
  votes: Maybe<Scalars['Int']>;
};

export type ProductRecommendation = {
  __typename?: 'ProductRecommendation';
  /**
   * Present only when the recommendation request failed; recommendedProducts is
   * then empty. Feeds the RecommendationFailed tracking event.
   */
  failure: Maybe<RecommendationFailure>;
  recommendationAttributes: Maybe<RecommendationAttribute>;
  recommendedProducts: Maybe<Array<Maybe<RecommendationProduct>>>;
};

export type ProductRoutine = {
  __typename?: 'ProductRoutine';
  description: Maybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type ProductRoutineAsset = {
  __typename?: 'ProductRoutineAsset';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
  type: Maybe<ProductRoutineAssetEnum>;
};

export enum ProductRoutineAssetEnum {
  Image = 'Image',
  Video = 'Video',
}

export type ProductRoutineAvailability = {
  __typename?: 'ProductRoutineAvailability';
  available: Scalars['Boolean'];
  routine: Maybe<Array<Maybe<ProductRoutineProduct>>>;
};

export type ProductRoutineProduct = {
  __typename?: 'ProductRoutineProduct';
  asset: Maybe<ProductRoutineAsset>;
  description: Maybe<Scalars['String']>;
  products: Maybe<Array<Maybe<ProductRoutine>>>;
  title: Maybe<Scalars['String']>;
};

export type ProductToCartInput = {
  count: Scalars['Int'];
  isComparisonPrice?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
};

export type ProductVariantCoreInfo = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  productCode: Maybe<Scalars['String']>;
  stockAvailability: Maybe<StockInfo>;
  url: Maybe<Scalars['String']>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  AppConfig: AppConfig;
  CartServicesIncluded: Maybe<ServicesIncluded>;
  ClientCache: Maybe<ClientCache>;
  CombinedAds: Maybe<SponsoredAdsResponse>;
  Footer: Maybe<Footer>;
  GetOrderCoupons: Maybe<OrderCoupons>;
  GetShoppingCart: Maybe<ShoppingCartModel>;
  ProductDetailAds: Maybe<SponsoredAdsProductDetailResponse>;
  ProductSsrData: Maybe<ClientProductSsr>;
  RequestHeaders: Maybe<ClientHeaders>;
  /** @deprecated Return default value. Use RichContentByCatalogMasterId */
  RichContentAvailable: RichContentAvailable;
  RichContentByCatalogMasterId: RichContent;
  /** @deprecated Return default value. Use RichContentByCatalogMasterId */
  RichContentData: RichContentAvailability;
  RoutineByCatalogId: ProductRoutineAvailability;
  RoutineByProductId: RoutineAvailability;
  Settings: Settings;
  VirtualTryOnAppearance: Maybe<VtoAppearanceResponse>;
  VirtualTryOnProductsByLookId: Maybe<VtoProductsResponse>;
  VirtualTryOnSettings: Maybe<VtoSettingsResponse>;
  VirtualTryOnShades: Maybe<VtoShadesResponse>;
  /** @deprecated Use WishlistByLoggedUserOrOwner */
  WishlistByLoggedUser: Maybe<Wishlist>;
  WishlistByLoggedUserOrOwner: Maybe<Wishlist>;
  /** @deprecated Use WishlistByLoggedUserOrOwner */
  WishlistByOwner: Maybe<Wishlist>;
  WishlistForCurrentUser: Maybe<FilterableWishlist>;
  WishlistListById: Maybe<WishlistList>;
  WishlistLists: Maybe<WishlistLists>;
  activeWatchdogs: Maybe<ActiveWatchdogsResponse>;
  brand: Maybe<Brand>;
  brands: Maybe<Array<Maybe<BrandItem>>>;
  checkUserNewsletterStatus: Scalars['Boolean'];
  collectStoresByCatalogId: Maybe<Array<ClickAndCollectStore>>;
  /** @deprecated Use collectStoresByCatalogId instead */
  collectStoresByProductId: Maybe<Array<ClickAndCollectStore>>;
  currencies: Maybe<Array<Maybe<Currency>>>;
  currentCurrency: Currency;
  currentLocale: Locale;
  dummy: Maybe<Scalars['String']>;
  /** @deprecated Use 'eventCalendars' instead */
  eventCalendarByYear: Array<Maybe<EventCalendarDay>>;
  eventCalendars: Maybe<Array<Maybe<EventCalendar>>>;
  externalReviewLink: Maybe<Scalars['String']>;
  freetext: Maybe<Freetext>;
  getArticles: Maybe<ArticlesQueryResponse>;
  getLivestreams: Maybe<GetLivestreamResponse>;
  getLoyaltyState: Maybe<LoyaltyState>;
  getOutOfStockAlternatives: Maybe<ProductRecommendation>;
  getProductRecommendations: Maybe<ProductRecommendation>;
  /** @deprecated Use getProductRecommendations instead */
  getRecommendedProducts: Array<Scalars['String']>;
  getShadefinder: Maybe<ShadefinderResponse>;
  getUpsellingProductRecommendations: Maybe<ProductRecommendation>;
  getUpsellingProductRecommendationsForMultiple: Maybe<ProductRecommendation>;
  /** @deprecated Use getUpsellingProductRecommendations instead */
  getUpsellingProducts: Array<Scalars['String']>;
  /** @deprecated Use getUpsellingProductRecommendationsForMultiple instead */
  getUpsellingProductsForMultiple: Array<Scalars['String']>;
  inactiveWatchdogs: Maybe<InactiveWatchdogsResponse>;
  languagedMessages: LanguagedMessage;
  languagedMessagesByPrefixes: LanguagedMessage;
  localeByShopId: Maybe<Locale>;
  locales: Maybe<Array<Maybe<Locale>>>;
  loggedInUserReview: Maybe<LoggedInUserReview>;
  pdFaq: Maybe<Array<PdFaqEntry>>;
  product: Product;
  productBySCode: Maybe<VpProduct>;
  productDetailByCatalogMasterId: Maybe<CatalogProduct>;
  /** @deprecated Use productDetailByCatalogMasterId instead */
  productDetailByMasterId: Maybe<Array<Maybe<Product>>>;
  productDetailByStore: Maybe<StoreProduct>;
  productIdBySCode: Maybe<Scalars['Int']>;
  productIdsByWebId: Maybe<ProductIdentifiers>;
  productListItemByMasterIds: Array<Maybe<MasterProductListItem>>;
  productMasterIdByVariantId: Maybe<Scalars['String']>;
  productsPriceById: Maybe<Array<Maybe<ProductPrice>>>;
  productsPriceByIdAndShop: Maybe<Array<Maybe<ProductPrice>>>;
  resolveUrl: PathView;
  reviewSubmissionConfig: Maybe<ReviewSubmissionConfig>;
  reviewableProducts: ReviewableProductsResponse;
  /** @deprecated use reviewsAndFilters instead */
  reviews: Array<Review>;
  /** @deprecated Use reviewsAndFiltersByMasterProductId, which is keyed by the integer masterProductId. */
  reviewsAndFilters: Maybe<ReviewsWithFilterResponse>;
  reviewsAndFiltersByMasterProductId: Maybe<ReviewsWithFilterResponse>;
  reviewsSummary: ReviewSummary;
  reviewsSummaryByCategorizationKinds: ReviewSummary;
  shopSettings: Maybe<Shop>;
  simpleProductAttributesByIds: Array<Maybe<SimpleProductAttributes>>;
  user: Maybe<User>;
  userProductsInfo: Maybe<Array<Maybe<UserProductInfo>>>;
  /** @deprecated Use userProductsInfo. Comparison price is determined by Product Id instead of Master Id as before. */
  userProductsInfoByMasterIds: Maybe<Array<Maybe<UserProductInfo>>>;
  validateText: ValidateTextResult;
  vpProductById: Maybe<VpProduct>;
  vpProductByIds: Array<Maybe<VpProduct>>;
  /** @deprecated Use watchdogState. Send catalogId instead of productId */
  watchdogActive: WatchdogActive;
  watchdogRegistered: WatchdogRegistered;
  watchdogState: WatchdogActive;
  watchdogs: Maybe<ClientWatchdogs>;
};

export type QueryCartServicesIncludedArgs = {
  productsIds: Scalars['String'];
};

export type QueryCombinedAdsArgs = {
  input?: InputMaybe<SponsoredAdsRequestInput>;
};

export type QueryGetOrderCouponsArgs = {
  orderCouponsInput: OrderCouponsInput;
};

export type QueryProductDetailAdsArgs = {
  input: ProductDetailAdsInput;
};

export type QueryRichContentAvailableArgs = {
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
};

export type QueryRichContentByCatalogMasterIdArgs = {
  catalogMasterId: Scalars['String'];
  targetPage?: InputMaybe<RichContentTargetPage>;
  versionKey?: InputMaybe<Scalars['String']>;
};

export type QueryRichContentDataArgs = {
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
};

export type QueryRoutineByCatalogIdArgs = {
  catalogId?: InputMaybe<Scalars['String']>;
  catalogMasterId?: InputMaybe<Scalars['String']>;
};

export type QueryRoutineByProductIdArgs = {
  masterProductId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type QueryVirtualTryOnAppearanceArgs = {
  catalogIds: Array<Scalars['Int']>;
  modifaceHairVersion?: InputMaybe<Scalars['String']>;
  modifaceMakeupVersion?: InputMaybe<Scalars['String']>;
  modifaceNailVersion?: InputMaybe<Scalars['String']>;
};

export type QueryVirtualTryOnProductsByLookIdArgs = {
  lookId: Scalars['Int'];
};

export type QueryVirtualTryOnShadesArgs = {
  catalogIds: Array<Scalars['Int']>;
  modifaceHairVersion?: InputMaybe<Scalars['String']>;
  modifaceMakeupVersion?: InputMaybe<Scalars['String']>;
  modifaceNailVersion?: InputMaybe<Scalars['String']>;
};

export type QueryWishlistByLoggedUserOrOwnerArgs = {
  includeLists?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['String']>;
};

export type QueryWishlistByOwnerArgs = {
  owner: Scalars['String'];
};

export type QueryWishlistForCurrentUserArgs = {
  count?: InputMaybe<Scalars['Int']>;
  include?: InputMaybe<WishlistForCurrentUserIncludeInput>;
  navigationValues?: InputMaybe<Array<Scalars['Int']>>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<WishlistSortBy>;
  wishlist?: InputMaybe<WishlistForCurrentUserWishlistInput>;
};

export type QueryWishlistListByIdArgs = {
  id: Scalars['String'];
};

export type QueryActiveWatchdogsArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryBrandArgs = {
  id: Scalars['Int'];
};

export type QueryCollectStoresByCatalogIdArgs = {
  catalogId: Scalars['Int'];
};

export type QueryCollectStoresByProductIdArgs = {
  productId: Scalars['Int'];
};

export type QueryEventCalendarByYearArgs = {
  type: Scalars['String'];
  year: Scalars['String'];
};

export type QueryEventCalendarsArgs = {
  type?: InputMaybe<EventCalendarType>;
};

export type QueryExternalReviewLinkArgs = {
  catalogId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
};

export type QueryFreetextArgs = {
  id: Scalars['String'];
};

export type QueryGetArticlesArgs = {
  variables: ArticlesQueryVariables;
};

export type QueryGetLivestreamsArgs = {
  variables: GetLivestreamVariables;
};

export type QueryGetOutOfStockAlternativesArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  navigationValues: Array<Scalars['Int']>;
  productCode: Scalars['String'];
};

export type QueryGetProductRecommendationsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  productCode: Scalars['String'];
};

export type QueryGetRecommendedProductsArgs = {
  productCode: Scalars['String'];
};

export type QueryGetShadefinderArgs = {
  productId: Scalars['String'];
};

export type QueryGetUpsellingProductRecommendationsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  productCode: Scalars['String'];
};

export type QueryGetUpsellingProductRecommendationsForMultipleArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  productCodes: Array<Scalars['String']>;
};

export type QueryGetUpsellingProductsArgs = {
  productCode: Scalars['String'];
};

export type QueryGetUpsellingProductsForMultipleArgs = {
  productCodes: Array<Scalars['String']>;
};

export type QueryInactiveWatchdogsArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryLanguagedMessagesByPrefixesArgs = {
  prefixes?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryLoggedInUserReviewArgs = {
  masterProductCode: Scalars['String'];
};

export type QueryPdFaqArgs = {
  masterProductCode: Scalars['String'];
};

export type QueryProductArgs = {
  productUrl: Scalars['String'];
};

export type QueryProductBySCodeArgs = {
  sCode: Scalars['String'];
};

export type QueryProductDetailByCatalogMasterIdArgs = {
  catalogMasterId: Scalars['String'];
};

export type QueryProductDetailByMasterIdArgs = {
  masterId: Scalars['String'];
};

export type QueryProductDetailByStoreArgs = {
  masterId: Scalars['String'];
  storeCode: Scalars['String'];
};

export type QueryProductIdBySCodeArgs = {
  sCode: Scalars['String'];
};

export type QueryProductIdsByWebIdArgs = {
  webId: Scalars['String'];
};

export type QueryProductListItemByMasterIdsArgs = {
  masterIds: Array<Scalars['String']>;
};

export type QueryProductMasterIdByVariantIdArgs = {
  productId: Scalars['String'];
};

export type QueryProductsPriceByIdArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryProductsPriceByIdAndShopArgs = {
  ids: Array<Scalars['String']>;
  shop?: InputMaybe<Scalars['String']>;
};

export type QueryResolveUrlArgs = {
  url: Scalars['String'];
};

export type QueryReviewableProductsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryReviewsArgs = {
  code: Scalars['String'];
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
  includeBlank?: InputMaybe<Scalars['Boolean']>;
  orderBy: ReviewOrderBy;
  orderDesc: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type QueryReviewsAndFiltersArgs = {
  code: Scalars['String'];
  contentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
  orderBy: ReviewOrderBy;
  orderDesc: Scalars['Boolean'];
  page: Scalars['Int'];
  rating?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type QueryReviewsAndFiltersByMasterProductIdArgs = {
  contentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
  masterProductId: Scalars['String'];
  orderBy: ReviewOrderBy;
  orderDesc: Scalars['Boolean'];
  page: Scalars['Int'];
  rating?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type QueryReviewsSummaryArgs = {
  masterProductCode: Scalars['String'];
  ratingFloorType: RatingFloortype;
};

export type QueryReviewsSummaryByCategorizationKindsArgs = {
  kinds: Array<CategorizationKind>;
  masterProductCode: Scalars['String'];
};

export type QuerySimpleProductAttributesByIdsArgs = {
  idType: ProductIdType;
  ids: Array<Scalars['String']>;
};

export type QueryUserProductsInfoArgs = {
  productIds: Array<Scalars['String']>;
};

export type QueryUserProductsInfoByMasterIdsArgs = {
  masterIds: Array<Scalars['String']>;
};

export type QueryValidateTextArgs = {
  text: Scalars['String'];
};

export type QueryVpProductByIdArgs = {
  id: Scalars['String'];
};

export type QueryVpProductByIdsArgs = {
  idType?: InputMaybe<ProductIdType>;
  ids: Array<Scalars['String']>;
};

export type QueryWatchdogActiveArgs = {
  productId: Scalars['String'];
};

export type QueryWatchdogRegisteredArgs = {
  catalogIds: Array<Scalars['Int']>;
};

export type QueryWatchdogStateArgs = {
  catalogId: Scalars['Int'];
};

export type QuickContact = {
  __typename?: 'QuickContact';
  contactInformationUrl: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phoneNumbers: Maybe<Array<Maybe<Scalars['String']>>>;
  workingHours: Maybe<Scalars['String']>;
};

export type RcContentInput = {
  isApproved?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rich?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type Rating = {
  id?: InputMaybe<Scalars['Int']>;
  ratingType?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
};

export enum RatingFloortype {
  Cosmetics = 'Cosmetics',
  Health = 'Health',
  Parfums = 'Parfums',
}

export type RecentMinPrice = {
  __typename?: 'RecentMinPrice';
  currency: Maybe<Scalars['String']>;
  isActionEligible: Maybe<Scalars['Boolean']>;
  tax: Maybe<Scalars['Float']>;
  value: Maybe<Scalars['Float']>;
};

export type RecommendationAttribute = {
  __typename?: 'RecommendationAttribute';
  attributionToken: Maybe<Scalars['String']>;
  engineName: Maybe<Scalars['String']>;
  provider: Maybe<Scalars['String']>;
  recommendationId: Maybe<Scalars['String']>;
};

export type RecommendationFailure = {
  __typename?: 'RecommendationFailure';
  /**
   * Why the recommendation request failed. "timeout" for timeouts (circuit
   * breaker or a 504 from the recommendation service), otherwise a
   * human-readable description.
   */
  message: Scalars['String'];
};

export type RecommendationProduct = {
  __typename?: 'RecommendationProduct';
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
};

export type RecommendedPrice = {
  __typename?: 'RecommendedPrice';
  currency: Scalars['String'];
  isConverted: Scalars['Boolean'];
  tax: Scalars['Float'];
  value: Scalars['Float'];
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  available: Scalars['Boolean'];
  mainImage: Scalars['String'];
  productId: Scalars['Int'];
  swatchImage: Maybe<Scalars['String']>;
  variantName: Scalars['String'];
};

export type Review = {
  __typename?: 'Review';
  agency: Maybe<ReviewAgency>;
  alreadyDisliked: Scalars['Boolean'];
  alreadyLiked: Scalars['Boolean'];
  attributes: Maybe<ReviewAttributes>;
  authorType: AuthorType;
  createdDate: Scalars['String'];
  dislike: Scalars['Int'];
  id: Scalars['Int'];
  images: Maybe<Array<ReviewImage>>;
  /** @deprecated use agency field instead */
  isAgencyTested: Maybe<Scalars['Boolean']>;
  isAnonymized: Scalars['Boolean'];
  like: Scalars['Int'];
  originalShopId: Maybe<Scalars['String']>;
  originalText: Maybe<Scalars['String']>;
  originalTitle: Maybe<Scalars['String']>;
  partnerDomain: Maybe<Scalars['String']>;
  score: Scalars['Int'];
  sourceLanguage: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  /** @deprecated always null, no longer used */
  translatedFrom: Maybe<Scalars['String']>;
  userName: Scalars['String'];
  variantId: Maybe<Scalars['Int']>;
};

export type ReviewAgency = {
  __typename?: 'ReviewAgency';
  name: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ReviewAttributes = {
  __typename?: 'ReviewAttributes';
  cons: Maybe<Array<Scalars['String']>>;
  pros: Maybe<Array<Scalars['String']>>;
};

export type ReviewContentTypeCount = {
  __typename?: 'ReviewContentTypeCount';
  count: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
};

export type ReviewFilter = {
  __typename?: 'ReviewFilter';
  contentTypes: Maybe<Array<ReviewContentTypeCount>>;
  rating: Maybe<ReviewRatingBuckets>;
  shops: Maybe<Array<ReviewShopCount>>;
  variants: Maybe<Array<ReviewVariantCount>>;
};

export type ReviewImage = {
  __typename?: 'ReviewImage';
  fullSizeUrl: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type ReviewImageUploadResponse = {
  __typename?: 'ReviewImageUploadResponse';
  errors: Maybe<Array<Scalars['String']>>;
  hasErrors: Scalars['Boolean'];
  successfullyUploaded: Maybe<Array<Scalars['String']>>;
};

export enum ReviewOrderBy {
  DateTime = 'DateTime',
  Favorite = 'Favorite',
  Rating = 'Rating',
}

export type ReviewOverview = {
  __typename?: 'ReviewOverview';
  count: Scalars['Int'];
  rating: Scalars['Float'];
  textReviewsCount: Scalars['Int'];
  translatedReviewsCount: Scalars['Int'];
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  id: Scalars['Int'];
  preciseScore: Scalars['Float'];
  ratingType: Scalars['String'];
  score: Scalars['Int'];
};

export type ReviewRatingBuckets = {
  __typename?: 'ReviewRatingBuckets';
  fiveStar: Maybe<Scalars['Int']>;
  fourStar: Maybe<Scalars['Int']>;
  oneStar: Maybe<Scalars['Int']>;
  threeStar: Maybe<Scalars['Int']>;
  twoStar: Maybe<Scalars['Int']>;
};

export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  reviewId: Maybe<Scalars['Int']>;
  success: Maybe<Scalars['Boolean']>;
};

export type ReviewResponseData = {
  __typename?: 'ReviewResponseData';
  page: Scalars['Int'];
  reviews: Array<Review>;
  totalPages: Scalars['Int'];
  totalReviews: Scalars['Int'];
};

export type ReviewShopCount = {
  __typename?: 'ReviewShopCount';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
};

/**
 * Limits the Review API enforces on review submission. Nullable as a whole -
 * when the API call fails the client falls back to its own defaults.
 */
export type ReviewSubmissionConfig = {
  __typename?: 'ReviewSubmissionConfig';
  images: ReviewSubmissionImagesConfig;
  name: ReviewSubmissionTextFieldConfig;
  rating: ReviewSubmissionRatingConfig;
  text: ReviewSubmissionTextFieldConfig;
  title: ReviewSubmissionTextFieldConfig;
};

export type ReviewSubmissionImagesConfig = {
  __typename?: 'ReviewSubmissionImagesConfig';
  allowedTypes: Array<Scalars['String']>;
  maxCount: Scalars['Int'];
  maxSizeBytes: Scalars['Int'];
  minHeight: Scalars['Int'];
  minWidth: Scalars['Int'];
};

export type ReviewSubmissionRatingConfig = {
  __typename?: 'ReviewSubmissionRatingConfig';
  max: Scalars['Int'];
  min: Scalars['Int'];
  required: Scalars['Boolean'];
};

export type ReviewSubmissionTextFieldConfig = {
  __typename?: 'ReviewSubmissionTextFieldConfig';
  maxLength: Scalars['Int'];
  required: Scalars['Boolean'];
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  averageRating: Scalars['Float'];
  ratings: Array<ReviewRating>;
  score: Scalars['Int'];
  totalVotes: Scalars['Int'];
  votes: Maybe<Scalars['JSON']>;
};

export type ReviewVariantCount = {
  __typename?: 'ReviewVariantCount';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
};

export enum ReviewVoteType {
  Dislike = 'dislike',
  Like = 'like',
}

export type ReviewableProduct = {
  __typename?: 'ReviewableProduct';
  catalogId: Scalars['Int'];
  latestOrderDate: Maybe<Scalars['String']>;
  product: Maybe<VpProduct>;
};

export type ReviewableProductsPager = {
  __typename?: 'ReviewableProductsPager';
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ReviewableProductsResponse = {
  __typename?: 'ReviewableProductsResponse';
  pager: Maybe<ReviewableProductsPager>;
  products: Array<ReviewableProduct>;
};

export type ReviewsWithFilterResponse = {
  __typename?: 'ReviewsWithFilterResponse';
  data: Maybe<ReviewResponseData>;
  filter: Maybe<ReviewFilter>;
};

export type RichContent = {
  __typename?: 'RichContent';
  content: Maybe<Scalars['JSON']>;
  isAvailable: Scalars['Boolean'];
};

export type RichContentAsFirstTabFeatureFlag = {
  __typename?: 'RichContentAsFirstTabFeatureFlag';
  brandIds: Maybe<Array<Maybe<Scalars['String']>>>;
  masterProductCodes: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RichContentAvailability = {
  __typename?: 'RichContentAvailability';
  available: Scalars['Boolean'];
  richContentData: Maybe<RichContentData>;
};

export type RichContentAvailable = {
  __typename?: 'RichContentAvailable';
  available: Scalars['Boolean'];
};

export type RichContentData = {
  __typename?: 'RichContentData';
  data: Maybe<Scalars['JSON']>;
};

export enum RichContentTargetPage {
  ProductDetail = 'ProductDetail',
  ProductReviews = 'ProductReviews',
}

export enum Roles {
  Admin = 'Admin',
  Anonymous = 'Anonymous',
  Customer = 'Customer',
  Superuser = 'Superuser',
}

export type Route = {
  __typename?: 'Route';
  component: Maybe<Scalars['String']>;
  exact: Maybe<Scalars['Boolean']>;
  path: Maybe<Scalars['String']>;
  rolesOnly: Maybe<Array<Maybe<Roles>>>;
};

export type Routine = {
  __typename?: 'Routine';
  asset: Maybe<RoutineProductAsset>;
  description: Maybe<Scalars['String']>;
  products: Maybe<Array<Maybe<RoutineProduct>>>;
  title: Maybe<Scalars['String']>;
};

export type RoutineAvailability = {
  __typename?: 'RoutineAvailability';
  available: Scalars['Boolean'];
  routines: Maybe<Array<Maybe<Routine>>>;
};

export type RoutineProduct = {
  __typename?: 'RoutineProduct';
  description: Maybe<Scalars['String']>;
  product: Maybe<VpProduct>;
};

export type RoutineProductAsset = {
  __typename?: 'RoutineProductAsset';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
  type: Maybe<ProductRoutineAssetEnum>;
};

export type SaveShadefinderUserDataResult = {
  __typename?: 'SaveShadefinderUserDataResult';
  success: Maybe<Scalars['Boolean']>;
};

export type SecondaryCurrency = {
  __typename?: 'SecondaryCurrency';
  code: Scalars['String'];
  exchangeRates: Maybe<Scalars['Float']>;
  priceDecimalPlaces: Scalars['Int'];
  priceFormat: Scalars['String'];
  symbol: Scalars['String'];
};

export enum SectionType {
  Other = 'Other',
  UpcomingHolidays = 'UpcomingHolidays',
  WhyShopAtNotino = 'WhyShopAtNotino',
}

export type SelfChoiceBox = {
  __typename?: 'SelfChoiceBox';
  sampleProductId: Maybe<Scalars['Int']>;
};

export type Seo = {
  __typename?: 'Seo';
  description: Maybe<Scalars['String']>;
  keywords: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ServiceDto = {
  __typename?: 'ServiceDto';
  cartItemId: Maybe<Scalars['Int']>;
  cartServiceItem: Maybe<Scalars['Int']>;
  groupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  ident: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  serviceName: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type ServiceItemsDto = {
  __typename?: 'ServiceItemsDto';
  ecoPackaging: Maybe<CartContentProduct>;
  fundRaising: Maybe<CartContentProduct>;
  giftPackagings: Array<CartContentProduct>;
  insurance: Maybe<CartContentProduct>;
};

export type ServicesIncluded = {
  __typename?: 'ServicesIncluded';
  engravingShow: Scalars['Boolean'];
  tryFirstShow: Scalars['Boolean'];
};

export type Settings = {
  __typename?: 'Settings';
  cloudflareSettings: Maybe<Cloudflare>;
  deliveriesDisplayMode: Maybe<Scalars['String']>;
  featureSwitches: Maybe<FeatureSwitches>;
  imageDomainPath: Scalars['String'];
  isAddToCartButtonAllowed: Maybe<Scalars['String']>;
  isAddToCartModalAllowed: Maybe<Scalars['String']>;
  isEngravingAllowed: Maybe<Scalars['String']>;
  isNewShoppingCartEndpointEnabled: Maybe<Scalars['Boolean']>;
  isRoutineAllowed: Maybe<Scalars['String']>;
  isWishlistAllowed: Maybe<Scalars['Boolean']>;
  /** @deprecated Configurable fields are no longer necessary due to url-resolver. */
  routes: Array<Maybe<Route>>;
  showUnitPrices: Maybe<Scalars['Boolean']>;
};

export type Shade = {
  __typename?: 'Shade';
  bright: Maybe<Undertones>;
  dark: Maybe<Undertones>;
  medium: Maybe<Undertones>;
  mediumDark: Maybe<Undertones>;
  ultraBright: Maybe<Undertones>;
};

export type ShadefinderRecommendationInput = {
  makeupScale: Scalars['String'];
  userSelectedVariant: Scalars['Boolean'];
  variantId?: InputMaybe<Scalars['Int']>;
};

export type ShadefinderResponse = {
  __typename?: 'ShadefinderResponse';
  available: Scalars['Boolean'];
  shades: Shade;
};

export type ShadefinderUserDataInput = {
  productId: Scalars['Int'];
  recommendation?: InputMaybe<
    Array<InputMaybe<ShadefinderRecommendationInput>>
  >;
  skinTone?: InputMaybe<Scalars['String']>;
  skinUnderTone?: InputMaybe<Scalars['String']>;
};

export type Shop = {
  __typename?: 'Shop';
  countryCode: Scalars['String'];
  defaultCurrency: DefaultCurrency;
  defaultLanguage: Language;
  emailAddressList: Maybe<EmailAddressList>;
  gdprSettings: GdprSettings;
  shopId: Scalars['String'];
  timeZoneIanaName: Maybe<Scalars['String']>;
  websiteHostAddress: Maybe<Scalars['String']>;
  websiteId: Scalars['Int'];
};

export type ShoppingCartModel = {
  __typename?: 'ShoppingCartModel';
  boxes: Maybe<ShoppingCartModel_Boxes>;
  cartId: Maybe<Scalars['String']>;
  delivery: Maybe<CartItemDto>;
  insurance: Maybe<CartItemDto>;
  items: Maybe<Array<Maybe<CartItemDto>>>;
  payment: Maybe<CartItemDto>;
  services: Maybe<Array<Maybe<ServiceDto>>>;
};

export type ShoppingCartModel_Boxes = {
  __typename?: 'ShoppingCartModel_boxes';
  /** default field */
  success: Maybe<Scalars['String']>;
};

export type SimpleProductAttributes = {
  __typename?: 'SimpleProductAttributes';
  additionalInfo: Maybe<Scalars['String']>;
  colors: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Maybe<Scalars['ID']>;
};

export type SkinAnalyzer = {
  __typename?: 'SkinAnalyzer';
  apiUrl: Scalars['String'];
  env: Scalars['String'];
};

export type SkinAnalyzerFeature = {
  __typename?: 'SkinAnalyzerFeature';
  banner: Scalars['String'];
  brands: Maybe<Array<Scalars['String']>>;
  pageUrl: Scalars['String'];
};

export type SocialIcon = {
  __typename?: 'SocialIcon';
  link: Maybe<Scalars['String']>;
  name: Maybe<SocialIconName>;
};

export enum SocialIconName {
  Blog = 'Blog',
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  Twitter = 'Twitter',
  YouTube = 'YouTube',
}

export type Sorter = {
  __typename?: 'Sorter';
  desc: Maybe<Scalars['Boolean']>;
  sortBy: Maybe<Scalars['String']>;
};

export type SorterInput = {
  desc: Scalars['Boolean'];
  sortBy: Scalars['String'];
};

export type SponsoredAdsBannersRequestInput = {
  count: Scalars['Int'];
  slotId?: InputMaybe<Scalars['String']>;
};

export type SponsoredAdsBrandsRequestInput = {
  count: Scalars['Int'];
  slotId?: InputMaybe<Scalars['String']>;
};

export type SponsoredAdsCarouselItemResponse = {
  __typename?: 'SponsoredAdsCarouselItemResponse';
  payloads: Maybe<SponsoredAdsPlacementPayloadsResponse>;
  products: Maybe<Array<SponsoredAdsProductResponse>>;
};

export type SponsoredAdsCarouselResponse = {
  __typename?: 'SponsoredAdsCarouselResponse';
  items: Maybe<Array<SponsoredAdsCarouselItemResponse>>;
  /** Ad-provider identifier for this placement (Criteo or Martailer). */
  provider: Maybe<Scalars['String']>;
};

export enum SponsoredAdsPlacement {
  Category = 'Category',
  Checkout = 'Checkout',
  Default = 'Default',
  GiftPage = 'GiftPage',
  Home = 'Home',
  Product = 'Product',
  SalesPage = 'SalesPage',
  Search = 'Search',
}

export type SponsoredAdsPlacementPayloadsResponse = {
  __typename?: 'SponsoredAdsPlacementPayloadsResponse';
  onClickPayload: Maybe<Scalars['String']>;
  onLoadPayload: Maybe<Scalars['String']>;
  onViewPayload: Maybe<Scalars['String']>;
};

export type SponsoredAdsProductDetailResponse = {
  __typename?: 'SponsoredAdsProductDetailResponse';
  productCarousel: Maybe<SponsoredAdsCarouselResponse>;
};

export type SponsoredAdsProductPayloadsResponse = {
  __typename?: 'SponsoredAdsProductPayloadsResponse';
  onBasketChangePayload: Maybe<Scalars['String']>;
  onClickPayload: Maybe<Scalars['String']>;
  onViewPayload: Maybe<Scalars['String']>;
  onWishlistPayload: Maybe<Scalars['String']>;
};

export type SponsoredAdsProductResponse = {
  __typename?: 'SponsoredAdsProductResponse';
  payloads: Maybe<SponsoredAdsProductPayloadsResponse>;
  productId: Maybe<Scalars['String']>;
  vpProduct: Maybe<VpProduct>;
};

export type SponsoredAdsProductsRequestInput = {
  count: Scalars['Int'];
  productId?: InputMaybe<Scalars['Int']>;
};

export type SponsoredAdsRequestInput = {
  sponsoredAds?: InputMaybe<Array<SponsoredAdsRequestModelInput>>;
};

export type SponsoredAdsRequestModelInput = {
  category?: InputMaybe<Scalars['String']>;
  discountValues?: InputMaybe<Array<Scalars['Int']>>;
  excludedCategories?: InputMaybe<Array<Scalars['Int']>>;
  excludedProducts?: InputMaybe<Array<Scalars['Int']>>;
  filters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  freeDelivery?: InputMaybe<Scalars['Boolean']>;
  placement?: InputMaybe<SponsoredAdsPlacement>;
  priceMax?: InputMaybe<Scalars['Float']>;
  priceMin?: InputMaybe<Scalars['Float']>;
  priceSource?: InputMaybe<Array<Scalars['String']>>;
  rating?: InputMaybe<Array<Scalars['Int']>>;
  requestIdentifier?: InputMaybe<Scalars['String']>;
  searchExp?: InputMaybe<Scalars['String']>;
  sponsoredBanners?: InputMaybe<Array<SponsoredAdsBannersRequestInput>>;
  sponsoredBrands?: InputMaybe<Array<SponsoredAdsBrandsRequestInput>>;
  sponsoredProducts?: InputMaybe<SponsoredAdsProductsRequestInput>;
};

export type SponsoredAdsResponse = {
  __typename?: 'SponsoredAdsResponse';
  sponsoredAds: Maybe<Array<SponsoredAdsResponseModel>>;
};

export type SponsoredAdsResponseModel = {
  __typename?: 'SponsoredAdsResponseModel';
  requestIdentifier: Maybe<Scalars['String']>;
  sponsoredBanners: Maybe<Array<SponsoredBannersResult>>;
  sponsoredBrands: Maybe<Array<SponsoredBrandsResult>>;
  sponsoredProducts: Maybe<Array<SponsoredProductsResult>>;
};

export type SponsoredBannersResult = {
  __typename?: 'SponsoredBannersResult';
  campaignId: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  productId: Scalars['Int'];
  slotId: Maybe<Scalars['String']>;
};

export type SponsoredBrandsResult = {
  __typename?: 'SponsoredBrandsResult';
  brandId: Maybe<Scalars['String']>;
  campaignId: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  slotId: Maybe<Scalars['String']>;
};

export type SponsoredProductsResult = {
  __typename?: 'SponsoredProductsResult';
  campaignId: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  productId: Scalars['Int'];
};

export enum StockAvailability {
  Last1 = 'Last1',
  Last2 = 'Last2',
  Last3 = 'Last3',
  Last4 = 'Last4',
  Last5 = 'Last5',
  MoreThan5 = 'MoreThan5',
  MoreThan20 = 'MoreThan20',
  OutOfStock = 'OutOfStock',
}

export type StockInfo = {
  __typename?: 'StockInfo';
  code: Maybe<Scalars['String']>;
  count: Maybe<Scalars['Int']>;
};

export type Store = {
  __typename?: 'Store';
  name: Maybe<Scalars['String']>;
  urlPath: Maybe<Scalars['String']>;
};

export type StoreProduct = {
  __typename?: 'StoreProduct';
  annotation: Maybe<Scalars['String']>;
  brandInfo: Maybe<Brand>;
  breadcrumb: Maybe<Array<Maybe<Breadcrumb>>>;
  catalogId: Maybe<Scalars['Int']>;
  categorization: Categorization;
  code: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  composition: Maybe<Array<Maybe<Characteristic>>>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: Maybe<Scalars['String']>;
  masterCode: Maybe<Scalars['String']>;
  related: Maybe<Array<Maybe<Scalars['Int']>>>;
  reviewOverview: Maybe<ReviewOverview>;
  subName: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  variantDisplayType: Maybe<VariantDisplayType>;
  variants: Maybe<Array<Maybe<Variant>>>;
};

export enum StrictSalesDisplayTypeFeatureFlag {
  Default = 'default',
  ShowBottomPriceAndTopPriceWhenVoucher = 'showBottomPriceAndTopPriceWhenVoucher',
  ShowBottomPriceWhenVoucher = 'showBottomPriceWhenVoucher',
}

export type Subscription = {
  __typename?: 'Subscription';
  dummy: Maybe<Scalars['String']>;
};

export type TableManipulatorInput = {
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  pager: PagerInput;
  sorter?: InputMaybe<SorterInput>;
};

export type Undertones = {
  __typename?: 'Undertones';
  cold: Maybe<DesiredShade>;
  neutral: Maybe<DesiredShade>;
  warm: Maybe<DesiredShade>;
};

export type UnitPrice = {
  __typename?: 'UnitPrice';
  perAmount: Maybe<Scalars['Int']>;
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type UnitPriceDetail = {
  __typename?: 'UnitPriceDetail';
  currency: Maybe<Scalars['String']>;
  perAmount: Maybe<Scalars['Int']>;
  tax: Maybe<Scalars['Float']>;
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  cartId: Maybe<Scalars['String']>;
  comparisonIds: Maybe<Scalars['String']>;
  consent: Array<Scalars['String']>;
  grd: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  info: Maybe<UserInfo>;
  ltag: Maybe<Scalars['String']>;
  role: Maybe<Roles>;
  sid: Maybe<Scalars['String']>;
  token: Maybe<Scalars['String']>;
  uid: Maybe<Scalars['String']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  lastName: Maybe<Scalars['String']>;
  lastName2: Maybe<Scalars['String']>;
};

export type UserProductInfo = {
  __typename?: 'UserProductInfo';
  isComparison: Maybe<Scalars['Boolean']>;
  productId: Maybe<Scalars['String']>;
};

export type ValidateTextResult = {
  __typename?: 'ValidateTextResult';
  forbiddenWords: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Maybe<Scalars['String']>;
};

export type Variant = ProductVariantCoreInfo & {
  __typename?: 'Variant';
  additionalInfo: Maybe<Scalars['String']>;
  additionalText: Maybe<Scalars['String']>;
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  availablePickUpStores: Maybe<Scalars['Int']>;
  campaignConfig: Maybe<CampaignConfig>;
  canBuy: Maybe<Scalars['Boolean']>;
  catalogId: Maybe<Scalars['Int']>;
  characteristics: Maybe<Array<Maybe<Characteristic>>>;
  color: Maybe<Scalars['String']>;
  colors: Maybe<Array<Maybe<Scalars['String']>>>;
  descriptionOverride: Maybe<Scalars['String']>;
  eanCode: Maybe<Scalars['String']>;
  engraving: Maybe<Engraving>;
  gender: Maybe<Scalars['String']>;
  /** @deprecated Use campaignConfig. */
  giftPackagingConfig: Maybe<GiftPackagingConfig>;
  hairModifaceEffects: Maybe<Array<Maybe<HairModifaceEffects>>>;
  id: Maybe<Scalars['ID']>;
  images: Maybe<Array<Maybe<Image>>>;
  imagesByCategory: Maybe<ImagesByCategory>;
  legalInformation: Maybe<LegalInformation>;
  maxOrderQty: Maybe<Scalars['Int']>;
  /** @deprecated Use modifaceData which contains more data for modiface */
  modifaceEffects: Maybe<Array<Maybe<ModifaceEffect>>>;
  modifaceMakeUpData: Maybe<Array<Maybe<Scalars['JSON']>>>;
  name: Maybe<Scalars['String']>;
  navigationValues: Maybe<Array<Maybe<Scalars['Int']>>>;
  nextDeliveryDate: Maybe<Scalars['String']>;
  orderCode: Maybe<Scalars['String']>;
  originalPrice: Maybe<OriginalPrice>;
  parameters: Maybe<Parameters>;
  price: Maybe<Price>;
  primaryCategories: PrimaryCategories;
  productCode: Maybe<Scalars['String']>;
  recentMinPrice: Maybe<RecentMinPrice>;
  seo: Maybe<Seo>;
  showWatchdog: Maybe<Scalars['Boolean']>;
  stockAvailability: Maybe<StockInfo>;
  type: Maybe<Scalars['String']>;
  unitPrice: Maybe<UnitPriceDetail>;
  url: Maybe<Scalars['String']>;
  variantName: Maybe<Scalars['String']>;
  videos: Maybe<Array<Maybe<Scalars['String']>>>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export enum VariantDisplayType {
  ColorPicker = 'ColorPicker',
  Default = 'Default',
  Select = 'Select',
  ShadesDrawer = 'ShadesDrawer',
  Thumbnail = 'Thumbnail',
  Tiles = 'Tiles',
}

export type VariantFeatures = {
  __typename?: 'VariantFeatures';
  availableSets: Maybe<ProductAvailableSets>;
  engraving: Maybe<Engraving>;
  hairVirtualTryOnModel: Maybe<HairModifaceEffects>;
  makeUpVirtualTryOnEffects: Maybe<ModifaceEffect>;
  perfumers: Maybe<Perfumers>;
  selfChoiceBox: Maybe<SelfChoiceBox>;
  versionedModifaceEffects: Maybe<Array<Maybe<VersionedModifaceEffects>>>;
};

export enum VariantGrouppingType {
  Size = 'Size',
}

export type VariantMedia = {
  __typename?: 'VariantMedia';
  mainImage: Maybe<Image>;
  others: Array<Image>;
  previewImage: Maybe<Image>;
  shadeImage: Maybe<Image>;
  videos: Array<Video>;
};

export type VersionedModifaceEffects = {
  __typename?: 'VersionedModifaceEffects';
  apiVersion: Maybe<Scalars['String']>;
  effects: Maybe<Array<Maybe<GenericModifaceEffect>>>;
  type: Maybe<Scalars['String']>;
};

export type Video = {
  __typename?: 'Video';
  id: Scalars['String'];
  type: VideoType;
};

export enum VideoType {
  Vimeo = 'Vimeo',
  Youtube = 'Youtube',
}

export type VitaminsAndMinerals = {
  __typename?: 'VitaminsAndMinerals';
  amount: Maybe<Scalars['Float']>;
  amountSign: Maybe<Scalars['String']>;
  measureUnit: Maybe<Scalars['String']>;
  nutritionValue: Maybe<Scalars['String']>;
  onePortionAmount: Maybe<Scalars['Float']>;
  referenceValue: Maybe<Scalars['Float']>;
  referenceValueOnePercent: Maybe<Scalars['Float']>;
  referenceValuePercent: Maybe<Scalars['Float']>;
};

export enum VoteAction {
  Add = 'add',
  Remove = 'remove',
}

export enum VoteType {
  Dislike = 'dislike',
  Like = 'like',
}

export type VoucherDto = {
  __typename?: 'VoucherDto';
  code: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  isDeliveryVoucher: Scalars['Boolean'];
  isPercentVoucher: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type VpProduct = ProductVariantCoreInfo & {
  __typename?: 'VpProduct';
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  brand: Maybe<Brand>;
  canBuy: Scalars['Boolean'];
  catalogId: Maybe<Scalars['Int']>;
  catalogMasterId: Maybe<Scalars['Int']>;
  config: ProductConfig;
  description: Maybe<Scalars['String']>;
  fullAnnotation: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  imageUrl: Maybe<Scalars['String']>;
  masterId: Maybe<Scalars['Int']>;
  masterProductCode: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  orderUnit: Maybe<Scalars['String']>;
  price: Maybe<Price>;
  primaryCategories: PrimaryCategories;
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  recommendedPrice: Maybe<RecommendedPrice>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview. */
  reviewSummary: Maybe<ReviewSummary>;
  showWatchdog: Scalars['Boolean'];
  stockAvailability: Maybe<StockInfo>;
  subName: Maybe<Scalars['String']>;
  unitPrice: Maybe<UnitPrice>;
  url: Maybe<Scalars['String']>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type VtoAppearanceProduct = {
  __typename?: 'VtoAppearanceProduct';
  look: VtoLook;
  productIds: Array<Scalars['Int']>;
};

export type VtoAppearanceResponse = {
  __typename?: 'VtoAppearanceResponse';
  products: Array<VtoAppearanceProduct>;
};

export enum VtoBeautyType {
  Hair = 'Hair',
  Makeup = 'Makeup',
  Nail = 'Nail',
  None = 'None',
}

export type VtoCategory = {
  __typename?: 'VtoCategory';
  localizedName: Scalars['String'];
  name: Scalars['String'];
  subcategories: Array<VtoCategoryName>;
  type: VtoCategoryType;
};

export type VtoCategoryName = {
  __typename?: 'VtoCategoryName';
  localizedName: Scalars['String'];
  name: Scalars['String'];
  type: VtoCategoryType;
};

export enum VtoCategoryType {
  All = 'All',
  Brand = 'Brand',
  Category = 'Category',
  Event = 'Event',
  None = 'None',
  VirtualBrand = 'VirtualBrand',
  VirtualCategory = 'VirtualCategory',
}

export type VtoLicenseKey = {
  __typename?: 'VtoLicenseKey';
  key: Scalars['String'];
  lookType: Scalars['String'];
};

export type VtoLocalizedText = {
  __typename?: 'VtoLocalizedText';
  description: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type VtoLook = {
  __typename?: 'VtoLook';
  categories: Array<VtoCategory>;
  effect: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl: Maybe<Scalars['String']>;
  localizedText: Maybe<VtoLocalizedText>;
  lookObject: Array<Scalars['JSON']>;
  lookType: VtoBeautyType;
  productsDualTotalPrice: Maybe<Scalars['Float']>;
  productsTotalCount: Scalars['Int'];
  productsTotalPrice: Scalars['Float'];
};

export type VtoPriceModel = {
  __typename?: 'VtoPriceModel';
  currency: Scalars['String'];
  dualPrice: Maybe<Scalars['Float']>;
  tax: Scalars['Float'];
  value: Scalars['Float'];
};

export type VtoProductBasic = {
  __typename?: 'VtoProductBasic';
  additionalInfo: Maybe<Scalars['String']>;
  annotation: Scalars['String'];
  brandName: Scalars['String'];
  canBuy: Scalars['Boolean'];
  colors: Array<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  maxOrderQty: Scalars['Int'];
  name: Scalars['String'];
  orderUnit: Maybe<Scalars['String']>;
  price: VtoPriceModel;
  productCode: Scalars['String'];
  productId: Scalars['Int'];
  stockAvailability: VtoStockAvailability;
  stockQuantity: Scalars['Int'];
  url: Maybe<Scalars['String']>;
  webProductId: Scalars['Int'];
  wishlisted: Scalars['Boolean'];
};

export type VtoProductsResponse = {
  __typename?: 'VtoProductsResponse';
  products: Array<VtoProductBasic>;
};

export type VtoSettingsResponse = {
  __typename?: 'VtoSettingsResponse';
  licenseKeys: Array<VtoLicenseKey>;
};

export type VtoShadesProduct = {
  __typename?: 'VtoShadesProduct';
  productId: Scalars['Int'];
  productType: VtoBeautyType;
  shades: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type VtoShadesResponse = {
  __typename?: 'VtoShadesResponse';
  products: Array<VtoShadesProduct>;
};

export enum VtoStockAvailability {
  Last1 = 'Last1',
  Last2 = 'Last2',
  Last3 = 'Last3',
  Last4 = 'Last4',
  Last5 = 'Last5',
  MoreThan5 = 'MoreThan5',
  MoreThan20 = 'MoreThan20',
  OutOfStock = 'OutOfStock',
}

export type WatchDog = {
  __typename?: 'WatchDog';
  errors: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type WatchdogActive = {
  __typename?: 'WatchdogActive';
  watchdogActive: Scalars['Boolean'];
};

export type Wishlist = {
  __typename?: 'Wishlist';
  id: Scalars['ID'];
  owner: Scalars['String'];
  products: Array<Maybe<Scalars['String']>>;
};

export type WishlistFiltration = {
  __typename?: 'WishlistFiltration';
  groupName: Scalars['String'];
  groupType: WishlistFiltrationGroupType;
  items: Array<WishlistFiltrationItem>;
  navigationProperty: Scalars['Int'];
};

export enum WishlistFiltrationGroupType {
  Brand = 'Brand',
  Category = 'Category',
  Default = 'Default',
  ForWho = 'ForWho',
  FreeGiftsAndOffers = 'FreeGiftsAndOffers',
}

export type WishlistFiltrationItem = {
  __typename?: 'WishlistFiltrationItem';
  count: Scalars['Int'];
  isSelected: Scalars['Boolean'];
  name: Scalars['String'];
  navigationValue: Scalars['Int'];
  propertyId: Scalars['Int'];
};

export type WishlistForCurrentUserIncludeInput = {
  missingProductIds?: InputMaybe<Scalars['Boolean']>;
};

export type WishlistForCurrentUserWishlistInput = {
  listId?: InputMaybe<Scalars['String']>;
  wishlistId?: InputMaybe<Scalars['String']>;
};

export type WishlistId = {
  __typename?: 'WishlistId';
  id: Scalars['ID'];
};

export type WishlistList = {
  __typename?: 'WishlistList';
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  products: Array<Scalars['Int']>;
};

export type WishlistListing = {
  __typename?: 'WishlistListing';
  hasMore: Scalars['Boolean'];
  products: Array<WishlistProduct>;
  selectedSortBy: WishlistSortBy;
  sortByOptions: Array<WishlistSortByOption>;
  totalProductCount: Scalars['Int'];
};

export type WishlistLists = {
  __typename?: 'WishlistLists';
  lists: Array<WishlistList>;
  productCount: Maybe<Scalars['Int']>;
};

export type WishlistProduct = {
  __typename?: 'WishlistProduct';
  product: Maybe<VpProduct>;
  webProductId: Scalars['Int'];
};

export type WishlistShareListResponse = {
  __typename?: 'WishlistShareListResponse';
  wishlistId: Scalars['String'];
};

export enum WishlistSortBy {
  Alphabetically = 'Alphabetically',
  BestSellers = 'BestSellers',
  Cheapest = 'Cheapest',
  Default = 'Default',
  MostExpensive = 'MostExpensive',
  TopRated = 'TopRated',
}

export type WishlistSortByOption = {
  __typename?: 'WishlistSortByOption';
  name: Scalars['String'];
  sortBy: WishlistSortBy;
};

export type WatchdogRegistered = {
  __typename?: 'watchdogRegistered';
  registeredEmails: Maybe<Scalars['JSON']>;
};

export type GetImageSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetImageSettingsQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type UpdatePathnameQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePathnameQuery = {
  __typename?: 'Query';
  ProductSsrData: {
    __typename?: 'ClientProductSsr';
    pathname: string | null;
    type: string | null;
  } | null;
};

export type UpdateResolveUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;

export type UpdateResolveUrlQuery = {
  __typename?: 'Query';
  resolveUrl: {
    __typename: 'PathView';
    id: string;
    path: string;
    type: PathTemplate;
    catalogId: string | null;
  };
};

export type GetLivestreamsQueryVariables = Exact<{
  variables: GetLivestreamVariables;
}>;

export type GetLivestreamsQuery = {
  __typename?: 'Query';
  getLivestreams: {
    __typename?: 'GetLivestreamResponse';
    shows: Array<{
      __typename?: 'Livestream';
      showId: string;
      title: string;
      description: string;
      previewImageUrl: string | null;
      videoLength: string;
      isLive: boolean;
      scheduledStart: string | null;
      scheduledDate: string;
      publishedDate: string | null;
      deeplink: string;
    }> | null;
  } | null;
};

export type GetPriceConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetPriceConfigQuery = {
  __typename?: 'Query';
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
};

export type GetProductsByIdBatchedQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  idType?: InputMaybe<ProductIdType>;
}>;

export type GetProductsByIdBatchedQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    masterProductCode: string | null;
    catalogMasterId: number | null;
    catalogId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    fullAnnotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string; id: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      rating: number;
      count: number;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string | null;
      subCategory: string | null;
      kind: string | null;
      type: string | null;
    };
  } | null>;
};

export type FragmentVpProductByIdBodyModifiedFragment = {
  __typename?: 'VpProduct';
  id: string | null;
  masterId: number | null;
  masterProductCode: string | null;
  catalogMasterId: number | null;
  catalogId: number | null;
  url: string | null;
  imageUrl: string | null;
  name: string | null;
  subName: string | null;
  annotation: string | null;
  fullAnnotation: string | null;
  productCode: string | null;
  wishlisted: boolean | null;
  attributes: any | null;
  showWatchdog: boolean;
  canBuy: boolean;
  price: {
    __typename?: 'Price';
    value: number | null;
    currency: string | null;
    tax: number | null;
  } | null;
  config: {
    __typename?: 'ProductConfig';
    showAddToCartModal: boolean | null;
    showAddToCartButton: boolean | null;
  };
  brand: { __typename?: 'Brand'; name: string; id: string } | null;
  stockAvailability: {
    __typename?: 'StockInfo';
    code: string | null;
    count: number | null;
  } | null;
  unitPrice: {
    __typename?: 'UnitPrice';
    value: number | null;
    unit: string | null;
    perAmount: number | null;
  } | null;
  reviewOverview: {
    __typename?: 'ReviewOverview';
    rating: number;
    count: number;
  } | null;
  primaryCategories: {
    __typename?: 'PrimaryCategories';
    category: string | null;
    subCategory: string | null;
    kind: string | null;
    type: string | null;
  };
};

export type GetItemDataByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetItemDataByIdQuery = {
  __typename?: 'Query';
  vpProductById: {
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    masterProductCode: string | null;
    catalogMasterId: number | null;
    catalogId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    fullAnnotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string; id: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      rating: number;
      count: number;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string | null;
      subCategory: string | null;
      kind: string | null;
      type: string | null;
    };
  } | null;
};

export type RoutineByCatalogIdQueryVariables = Exact<{
  catalogId: Scalars['String'];
  catalogMasterId: Scalars['String'];
}>;

export type RoutineByCatalogIdQuery = {
  __typename?: 'Query';
  RoutineByCatalogId: {
    __typename?: 'ProductRoutineAvailability';
    available: boolean;
    routine: Array<{
      __typename?: 'ProductRoutineProduct';
      description: string | null;
      title: string | null;
      asset: {
        __typename?: 'ProductRoutineAsset';
        type: ProductRoutineAssetEnum | null;
        alt: string | null;
        src: string | null;
      } | null;
      products: Array<{
        __typename?: 'ProductRoutine';
        description: string | null;
        productId: string;
      } | null> | null;
    } | null> | null;
  };
};

export type RoutineByProductIdQueryVariables = Exact<{
  productId: Scalars['Int'];
  masterProductId: Scalars['Int'];
}>;

export type RoutineByProductIdQuery = {
  __typename?: 'Query';
  RoutineByProductId: {
    __typename?: 'RoutineAvailability';
    available: boolean;
    routines: Array<{
      __typename?: 'Routine';
      description: string | null;
      title: string | null;
      asset: {
        __typename?: 'RoutineProductAsset';
        type: ProductRoutineAssetEnum | null;
        alt: string | null;
        src: string | null;
      } | null;
      products: Array<{
        __typename?: 'RoutineProduct';
        description: string | null;
        product: {
          __typename?: 'VpProduct';
          id: string | null;
          masterId: number | null;
          masterProductCode: string | null;
          catalogMasterId: number | null;
          catalogId: number | null;
          url: string | null;
          imageUrl: string | null;
          name: string | null;
          subName: string | null;
          annotation: string | null;
          fullAnnotation: string | null;
          productCode: string | null;
          wishlisted: boolean | null;
          attributes: any | null;
          showWatchdog: boolean;
          canBuy: boolean;
          price: {
            __typename?: 'Price';
            value: number | null;
            currency: string | null;
            tax: number | null;
          } | null;
          config: {
            __typename?: 'ProductConfig';
            showAddToCartModal: boolean | null;
            showAddToCartButton: boolean | null;
          };
          brand: { __typename?: 'Brand'; name: string; id: string } | null;
          stockAvailability: {
            __typename?: 'StockInfo';
            code: string | null;
            count: number | null;
          } | null;
          unitPrice: {
            __typename?: 'UnitPrice';
            value: number | null;
            unit: string | null;
            perAmount: number | null;
          } | null;
          reviewOverview: {
            __typename?: 'ReviewOverview';
            rating: number;
            count: number;
          } | null;
          primaryCategories: {
            __typename?: 'PrimaryCategories';
            category: string | null;
            subCategory: string | null;
            kind: string | null;
            type: string | null;
          };
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type CreateListMutationVariables = Exact<{
  name: Scalars['String'];
  productIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type CreateListMutation = {
  __typename?: 'Mutation';
  WishlistCreateList: {
    __typename?: 'WishlistList';
    id: string;
    name: string | null;
    products: Array<number>;
  } | null;
};

export type WishlistDeleteListMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type WishlistDeleteListMutation = {
  __typename?: 'Mutation';
  WishlistDeleteList: boolean | null;
};

export type RenameListMutationVariables = Exact<{
  listId: Scalars['String'];
  name: Scalars['String'];
}>;

export type RenameListMutation = {
  __typename?: 'Mutation';
  WishlistUpdateList: boolean | null;
};

export type WishlistShareListMutationVariables = Exact<{
  listId: Scalars['String'];
  sharedListId?: InputMaybe<Scalars['String']>;
}>;

export type WishlistShareListMutation = {
  __typename?: 'Mutation';
  WishlistShareList: {
    __typename?: 'WishlistShareListResponse';
    wishlistId: string;
  } | null;
};

export type WishlistListsQueryVariables = Exact<{ [key: string]: never }>;

export type WishlistListsQuery = {
  __typename?: 'Query';
  WishlistLists: {
    __typename?: 'WishlistLists';
    lists: Array<{
      __typename?: 'WishlistList';
      id: string;
      name: string | null;
      products: Array<number>;
    }>;
  } | null;
};

export type WishlistMutateListsMutationVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
  addToList: Array<Scalars['String']> | Scalars['String'];
  removeFromList: Array<Scalars['String']> | Scalars['String'];
}>;

export type WishlistMutateListsMutation = {
  __typename?: 'Mutation';
  WishlistMutateLists: {
    __typename?: 'WishlistLists';
    productCount: number | null;
    lists: Array<{
      __typename?: 'WishlistList';
      id: string;
      name: string | null;
      products: Array<number>;
    }>;
  } | null;
};

export type GetProductPathNameQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductPathNameQuery = {
  __typename?: 'Query';
  ProductSsrData: {
    __typename?: 'ClientProductSsr';
    pathname: string | null;
  } | null;
};

export type GetProductWebViewQueryVariables = Exact<{
  url: Scalars['String'];
}>;

export type GetProductWebViewQuery = {
  __typename?: 'Query';
  resolveUrl: {
    __typename: 'PathView';
    id: string;
    path: string;
    type: PathTemplate;
    catalogId: string | null;
  };
};

export type GetLocalesDataQueryVariables = Exact<{
  prefixes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetLocalesDataQuery = {
  __typename?: 'Query';
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
  languagedMessagesByPrefixes: {
    __typename?: 'LanguagedMessage';
    acceptLanguage: string;
    messages: any | null;
  };
};

export type GetBlogArticlesQueryVariables = Exact<{
  variables: ArticlesQueryVariables;
}>;

export type GetBlogArticlesQuery = {
  __typename?: 'Query';
  getArticles: {
    __typename?: 'ArticlesQueryResponse';
    articles: Array<{
      __typename?: 'BlogArticle';
      title: string;
      url: string;
      hreflangId: string | null;
      image: {
        __typename?: 'BlogArticleImage';
        url: string | null;
        alt: string | null;
      } | null;
    }>;
  } | null;
};

export type GetPdFaqQueryVariables = Exact<{
  masterProductCode: Scalars['String'];
}>;

export type GetPdFaqQuery = {
  __typename?: 'Query';
  pdFaq: Array<{ __typename?: 'PdFaqEntry'; q: string; a: string }> | null;
};

export type AddToClickAndCollectMutationVariables = Exact<{
  warehouseCode: Scalars['String'];
  productId: Scalars['Int'];
}>;

export type AddToClickAndCollectMutation = {
  __typename?: 'Mutation';
  addProductToClickAndCollect: {
    __typename?: 'ShoppingCartModel';
    cartId: string | null;
  } | null;
};

export type GetStoresQueryVariables = Exact<{
  catalogId: Scalars['Int'];
}>;

export type GetStoresQuery = {
  __typename?: 'Query';
  collectStoresByCatalogId: Array<{
    __typename?: 'ClickAndCollectStore';
    name: string;
    code: string;
    description: string;
    stockCount: StockAvailability;
    earliestPickup: string;
    isOverloaded: boolean | null;
  }> | null;
};

export type GetLoyaltyStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetLoyaltyStateQuery = {
  __typename?: 'Query';
  getLoyaltyState: {
    __typename?: 'LoyaltyState';
    state: LoyaltyStateEnum | null;
  } | null;
};

export type CheckUserNewsletterStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CheckUserNewsletterStatusQuery = {
  __typename?: 'Query';
  checkUserNewsletterStatus: boolean;
};

export type RegisterCustomerForLoyaltyProgramMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RegisterCustomerForLoyaltyProgramMutation = {
  __typename?: 'Mutation';
  registerCustomerForLoyaltyProgram: boolean | null;
};

export type SaveShadefinderUserDataMutationVariables = Exact<{
  userData: ShadefinderUserDataInput;
}>;

export type SaveShadefinderUserDataMutation = {
  __typename?: 'Mutation';
  saveShadefinderUserData: {
    __typename?: 'SaveShadefinderUserDataResult';
    success: boolean | null;
  } | null;
};

export type GetShadefinderAppIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetShadefinderAppIdQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    shadefinderAppId: string | null;
  } | null;
};

export type GetShadefinderQueryQueryVariables = Exact<{
  productId: Scalars['String'];
}>;

export type GetShadefinderQueryQuery = {
  __typename?: 'Query';
  getShadefinder: {
    __typename?: 'ShadefinderResponse';
    available: boolean;
    shades: {
      __typename?: 'Shade';
      ultraBright: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      bright: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      medium: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      mediumDark: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      dark: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type UndertoneFragmentFragment = {
  __typename?: 'Undertones';
  cold: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
  neutral: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
  warm: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
};

export type GetShopIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetShopIdQuery = {
  __typename?: 'Query';
  RequestHeaders: { __typename?: 'ClientHeaders'; shopId: string } | null;
};

export type AddToCartTryFirstMutationVariables = Exact<{
  productCode: Scalars['String'];
  productId: Scalars['String'];
  tryItFirstId: Scalars['String'];
}>;

export type AddToCartTryFirstMutation = {
  __typename?: 'Mutation';
  TryItFirstAddToCart: {
    __typename?: 'AddToCartTryItFirstResult';
    status: Array<CartProductStatus> | null;
  };
};

export type GetProductCodeByWebIdQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetProductCodeByWebIdQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    productCode: string | null;
  } | null>;
};

export type SimpleProductAttributesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  idType: ProductIdType;
}>;

export type SimpleProductAttributesByIdsQuery = {
  __typename?: 'Query';
  simpleProductAttributesByIds: Array<{
    __typename?: 'SimpleProductAttributes';
    id: string | null;
    additionalInfo: string | null;
    colors: Array<string | null> | null;
  } | null>;
};

export type ProductInfoQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type ProductInfoQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    collection: string | null;
    annotation: string | null;
    variants: Array<{
      __typename?: 'CatalogVariant';
      attributes: any | null;
      media: {
        __typename?: 'VariantMedia';
        mainImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        } | null;
      } | null;
    }>;
    brand: { __typename?: 'Brand'; name: string } | null;
  } | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type GetReviewSubmissionConfigQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetReviewSubmissionConfigQuery = {
  __typename?: 'Query';
  reviewSubmissionConfig: {
    __typename?: 'ReviewSubmissionConfig';
    name: {
      __typename?: 'ReviewSubmissionTextFieldConfig';
      maxLength: number;
      required: boolean;
    };
    title: {
      __typename?: 'ReviewSubmissionTextFieldConfig';
      maxLength: number;
      required: boolean;
    };
    text: {
      __typename?: 'ReviewSubmissionTextFieldConfig';
      maxLength: number;
      required: boolean;
    };
    rating: {
      __typename?: 'ReviewSubmissionRatingConfig';
      min: number;
      max: number;
      required: boolean;
    };
    images: {
      __typename?: 'ReviewSubmissionImagesConfig';
      maxCount: number;
      maxSizeBytes: number;
      allowedTypes: Array<string>;
      minWidth: number;
      minHeight: number;
    };
  } | null;
};

export type GetUserNameQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserNameQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    userName: string | null;
  } | null;
};

export type GetReviewableProductsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']>;
}>;

export type GetReviewableProductsQuery = {
  __typename?: 'Query';
  reviewableProducts: {
    __typename?: 'ReviewableProductsResponse';
    products: Array<{
      __typename?: 'ReviewableProduct';
      catalogId: number;
      product: {
        __typename?: 'VpProduct';
        id: string | null;
        name: string | null;
        url: string | null;
        imageUrl: string | null;
        description: string | null;
        productCode: string | null;
        annotation: string | null;
        wishlisted: boolean | null;
        showWatchdog: boolean;
        brand: { __typename?: 'Brand'; name: string } | null;
        price: {
          __typename?: 'Price';
          value: number | null;
          currency: string | null;
          tax: number | null;
        } | null;
        stockAvailability: {
          __typename?: 'StockInfo';
          code: string | null;
        } | null;
        reviewOverview: {
          __typename?: 'ReviewOverview';
          rating: number;
        } | null;
        primaryCategories: {
          __typename?: 'PrimaryCategories';
          category: string | null;
          subCategory: string | null;
          kind: string | null;
          type: string | null;
        };
      } | null;
    }>;
  };
};

export type AddReviewMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<InputMaybe<Rating>> | InputMaybe<Rating>>;
  score: Scalars['Int'];
  name: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  source: Scalars['String'];
  digests?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  captchaToken?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['Int']>;
  expectedImageCount?: InputMaybe<Scalars['Int']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type AddReviewMutation = {
  __typename?: 'Mutation';
  addReview: {
    __typename?: 'ReviewResponse';
    success: boolean | null;
    reviewId: number | null;
  } | null;
};

export type UploadReviewImagesMutationVariables = Exact<{
  reviewId: Scalars['Int'];
  images: Array<Scalars['Upload']> | Scalars['Upload'];
}>;

export type UploadReviewImagesMutation = {
  __typename?: 'Mutation';
  uploadReviewImages: {
    __typename?: 'ReviewImageUploadResponse';
    errors: Array<string> | null;
    hasErrors: boolean;
    successfullyUploaded: Array<string> | null;
  } | null;
};

export type HandleVoteMutationVariables = Exact<{
  id: Scalars['String'];
  type: VoteType;
  action: VoteAction;
}>;

export type HandleVoteMutation = {
  __typename?: 'Mutation';
  handleVote: {
    __typename?: 'Review';
    id: number;
    like: number;
    dislike: number;
    alreadyLiked: boolean;
    alreadyDisliked: boolean;
  } | null;
};

export type GetRichContentByCatalogMasterIdQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
}>;

export type GetRichContentByCatalogMasterIdQuery = {
  __typename?: 'Query';
  RichContentByCatalogMasterId: {
    __typename?: 'RichContent';
    isAvailable: boolean;
    content: any | null;
  };
};

export type GetCombinedAdsProductsQueryVariables = Exact<{
  input?: InputMaybe<SponsoredAdsRequestInput>;
}>;

export type GetCombinedAdsProductsQuery = {
  __typename?: 'Query';
  CombinedAds: {
    __typename?: 'SponsoredAdsResponse';
    sponsoredAds: Array<{
      __typename?: 'SponsoredAdsResponseModel';
      sponsoredProducts: Array<{
        __typename?: 'SponsoredProductsResult';
        productId: number;
        campaignId: string | null;
      }> | null;
    }> | null;
  } | null;
};

export type ReportSponsoredAdsProductClickMutationVariables = Exact<{
  url: Scalars['String'];
  campaignId: Scalars['String'];
}>;

export type ReportSponsoredAdsProductClickMutation = {
  __typename?: 'Mutation';
  reportSponsoredAdsProductClick: boolean | null;
};

export type ReportSponsoredAdsProductImpressionMutationVariables = Exact<{
  url: Scalars['String'];
  campaignId: Scalars['String'];
}>;

export type ReportSponsoredAdsProductImpressionMutation = {
  __typename?: 'Mutation';
  reportSponsoredAdsProductImpression: boolean | null;
};

export type GetProductDetailAdsQueryVariables = Exact<{
  input: ProductDetailAdsInput;
}>;

export type GetProductDetailAdsQuery = {
  __typename?: 'Query';
  ProductDetailAds: {
    __typename?: 'SponsoredAdsProductDetailResponse';
    productCarousel: {
      __typename?: 'SponsoredAdsCarouselResponse';
      provider: string | null;
      items: Array<{
        __typename?: 'SponsoredAdsCarouselItemResponse';
        products: Array<{
          __typename?: 'SponsoredAdsProductResponse';
          productId: string | null;
          vpProduct: {
            __typename?: 'VpProduct';
            id: string | null;
            masterId: number | null;
            masterProductCode: string | null;
            catalogMasterId: number | null;
            catalogId: number | null;
            url: string | null;
            imageUrl: string | null;
            name: string | null;
            subName: string | null;
            annotation: string | null;
            fullAnnotation: string | null;
            productCode: string | null;
            wishlisted: boolean | null;
            attributes: any | null;
            showWatchdog: boolean;
            canBuy: boolean;
            price: {
              __typename?: 'Price';
              value: number | null;
              currency: string | null;
              tax: number | null;
            } | null;
            config: {
              __typename?: 'ProductConfig';
              showAddToCartModal: boolean | null;
              showAddToCartButton: boolean | null;
            };
            brand: { __typename?: 'Brand'; name: string; id: string } | null;
            stockAvailability: {
              __typename?: 'StockInfo';
              code: string | null;
              count: number | null;
            } | null;
            unitPrice: {
              __typename?: 'UnitPrice';
              value: number | null;
              unit: string | null;
              perAmount: number | null;
            } | null;
            reviewOverview: {
              __typename?: 'ReviewOverview';
              rating: number;
              count: number;
            } | null;
            primaryCategories: {
              __typename?: 'PrimaryCategories';
              category: string | null;
              subCategory: string | null;
              kind: string | null;
              type: string | null;
            };
          } | null;
          payloads: {
            __typename?: 'SponsoredAdsProductPayloadsResponse';
            onViewPayload: string | null;
            onClickPayload: string | null;
            onBasketChangePayload: string | null;
            onWishlistPayload: string | null;
          } | null;
        }> | null;
        payloads: {
          __typename?: 'SponsoredAdsPlacementPayloadsResponse';
          onLoadPayload: string | null;
          onViewPayload: string | null;
          onClickPayload: string | null;
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type VirtualTryOnAppearanceQueryVariables = Exact<{
  catalogIds: Array<Scalars['Int']> | Scalars['Int'];
  modifaceMakeupVersion?: InputMaybe<Scalars['String']>;
  modifaceHairVersion?: InputMaybe<Scalars['String']>;
  modifaceNailVersion?: InputMaybe<Scalars['String']>;
}>;

export type VirtualTryOnAppearanceQuery = {
  __typename?: 'Query';
  VirtualTryOnAppearance: {
    __typename?: 'VtoAppearanceResponse';
    products: Array<{
      __typename?: 'VtoAppearanceProduct';
      productIds: Array<number>;
      look: {
        __typename?: 'VtoLook';
        id: number;
        effect: string | null;
        imageUrl: string | null;
        lookType: VtoBeautyType;
        productsTotalPrice: number;
        productsDualTotalPrice: number | null;
        productsTotalCount: number;
        lookObject: Array<any>;
        localizedText: {
          __typename?: 'VtoLocalizedText';
          name: string;
          description: string;
          isAvailable: boolean;
        } | null;
        categories: Array<{
          __typename?: 'VtoCategory';
          name: string;
          localizedName: string;
          type: VtoCategoryType;
          subcategories: Array<{
            __typename?: 'VtoCategoryName';
            localizedName: string;
            name: string;
            type: VtoCategoryType;
          }>;
        }>;
      };
    }>;
  } | null;
};

export type VirtualTryOnProductsByLookIdQueryVariables = Exact<{
  lookId: Scalars['Int'];
}>;

export type VirtualTryOnProductsByLookIdQuery = {
  __typename?: 'Query';
  VirtualTryOnProductsByLookId: {
    __typename?: 'VtoProductsResponse';
    products: Array<{
      __typename?: 'VtoProductBasic';
      id: string;
      productId: number;
      webProductId: number;
      url: string | null;
      imageUrl: string | null;
      brandName: string;
      name: string;
      maxOrderQty: number;
      stockAvailability: VtoStockAvailability;
      stockQuantity: number;
      orderUnit: string | null;
      canBuy: boolean;
      colors: Array<string>;
      annotation: string;
      additionalInfo: string | null;
      productCode: string;
      wishlisted: boolean;
      price: {
        __typename?: 'VtoPriceModel';
        value: number;
        currency: string;
        tax: number;
        dualPrice: number | null;
      };
    }>;
  } | null;
};

export type VirtualTryOnShadesQueryVariables = Exact<{
  catalogIds: Array<Scalars['Int']> | Scalars['Int'];
  modifaceMakeupVersion?: InputMaybe<Scalars['String']>;
  modifaceHairVersion?: InputMaybe<Scalars['String']>;
  modifaceNailVersion?: InputMaybe<Scalars['String']>;
}>;

export type VirtualTryOnShadesQuery = {
  __typename?: 'Query';
  VirtualTryOnShades: {
    __typename?: 'VtoShadesResponse';
    products: Array<{
      __typename?: 'VtoShadesProduct';
      productId: number;
      productType: VtoBeautyType;
      shades: Array<any | null> | null;
    }>;
  } | null;
};

export type HasWebcamQueryVariables = Exact<{ [key: string]: never }>;

export type HasWebcamQuery = {
  __typename?: 'Query';
  ClientCache: { __typename?: 'ClientCache'; hasWebcam: boolean | null } | null;
};

export type GetSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSettingsQuery = {
  __typename?: 'Query';
  Settings: {
    __typename?: 'Settings';
    isNewShoppingCartEndpointEnabled: boolean | null;
    showUnitPrices: boolean | null;
    imageDomainPath: string;
  };
};

export type GetOutOfStockAlternativesQueryVariables = Exact<{
  productCode: Scalars['String'];
  navigationValues: Array<Scalars['Int']> | Scalars['Int'];
  brandId?: InputMaybe<Scalars['Int']>;
}>;

export type GetOutOfStockAlternativesQuery = {
  __typename?: 'Query';
  getOutOfStockAlternatives: {
    __typename?: 'ProductRecommendation';
    recommendationAttributes: {
      __typename?: 'RecommendationAttribute';
      attributionToken: string | null;
      provider: string | null;
      recommendationId: string | null;
      engineName: string | null;
    } | null;
    recommendedProducts: Array<{
      __typename?: 'RecommendationProduct';
      productId: string | null;
    } | null> | null;
    failure: { __typename?: 'RecommendationFailure'; message: string } | null;
  } | null;
};

export type GetCatalogProductViewQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type GetCatalogProductViewQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    webMasterId: string;
    catalogMasterId: string;
    masterProductCode: string;
    description: string | null;
    descriptionType: string | null;
    annotation: string | null;
    subName: string | null;
    collection: string | null;
    url: string;
    gender: Gender | null;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    isPerfume: boolean | null;
    related: Array<number>;
    isForbiddenToDisplay: boolean | null;
    variantDisplayType: VariantDisplayType | null;
    variantGrouppingType: VariantGrouppingType | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      count: number;
      rating: number;
      textReviewsCount: number;
      translatedReviewsCount: number;
    } | null;
    brand: {
      __typename?: 'Brand';
      id: string;
      name: string;
      url: string | null;
      description: string | null;
      market: string | null;
      manufacturer: string | null;
      postalAddress: string | null;
      contactAddress: string | null;
      producer: {
        __typename?: 'BrandProducer';
        postalAddress: string | null;
      } | null;
    } | null;
    features: {
      __typename?: 'ProductDetailFeatures';
      isShadeFinderAvailable: boolean | null;
      composition: Array<{
        __typename?: 'Characteristic';
        help: string | null;
        name: string | null;
        values: Array<string | null> | null;
      }> | null;
      availableSets: {
        __typename?: 'ProductAvailableSets';
        sets: Array<{
          __typename?: 'ProductAvailableSet';
          catalogId: number | null;
          type: ProductAvailableSetType | null;
        } | null> | null;
      } | null;
      selfChoiceBox: {
        __typename?: 'SelfChoiceBox';
        sampleProductId: number | null;
      } | null;
      accessories: {
        __typename?: 'ProductAccessories';
        products: Array<{
          __typename?: 'ProductAccessory';
          catalogId: number | null;
        }> | null;
      } | null;
      skinAnalyzer: {
        __typename?: 'SkinAnalyzerFeature';
        banner: string;
        brands: Array<string> | null;
        pageUrl: string;
      } | null;
      hairAnalyzer: {
        __typename?: 'HairAnalyzerFeature';
        banner: string | null;
        brands: Array<string> | null;
      } | null;
    };
    variants: Array<{
      __typename?: 'CatalogVariant';
      webId: string;
      catalogId: string;
      name: string | null;
      variantName: string | null;
      orderCode: string | null;
      productCode: string;
      eanCode: string;
      annotation: string | null;
      additionalInfo: string;
      additionalText: string | null;
      gender: Gender | null;
      url: string;
      attributes: any | null;
      navigationValues: Array<number>;
      descriptionOverride: string | null;
      variantType: string | null;
      colors: Array<string | null> | null;
      wishlisted: boolean | null;
      features: {
        __typename?: 'VariantFeatures';
        availableSets: {
          __typename?: 'ProductAvailableSets';
          sets: Array<{
            __typename?: 'ProductAvailableSet';
            catalogId: number | null;
            type: ProductAvailableSetType | null;
          } | null> | null;
        } | null;
        selfChoiceBox: {
          __typename?: 'SelfChoiceBox';
          sampleProductId: number | null;
        } | null;
        engraving: {
          __typename?: 'Engraving';
          allowed: boolean;
          characterCount: number;
          image: string | null;
          config: {
            __typename?: 'EngravingConfig';
            isAvailable: boolean;
            price: number | null;
          };
        } | null;
        versionedModifaceEffects: Array<{
          __typename?: 'VersionedModifaceEffects';
          apiVersion: string | null;
          type: string | null;
          effects: Array<{
            __typename?: 'GenericModifaceEffect';
            upc: string | null;
            category: string | null;
            shades: any | null;
          } | null> | null;
        } | null> | null;
        perfumers: {
          __typename?: 'Perfumers';
          items: Array<{
            __typename?: 'PerfumerItem';
            name: string;
            imageUrl: string;
          } | null> | null;
        } | null;
      } | null;
      metaData: {
        __typename?: 'Seo';
        title: string | null;
        description: string | null;
        keywords: string | null;
      };
      parameters: {
        __typename?: 'Parameters';
        amount: number | null;
        package: string | null;
        unit: string | null;
      } | null;
      price: {
        __typename?: 'Price';
        value: number | null;
        currency: string | null;
        tax: number | null;
      };
      originalPrice: {
        __typename?: 'OriginalPrice';
        value: number | null;
        currency: string | null;
        tax: number | null;
        type: string | null;
      } | null;
      unitPrice: {
        __typename?: 'UnitPriceDetail';
        value: number | null;
        currency: string | null;
        tax: number | null;
        unit: string | null;
        perAmount: number | null;
      } | null;
      recentMinPrice: {
        __typename?: 'RecentMinPrice';
        value: number | null;
        currency: string | null;
        tax: number | null;
        isActionEligible: boolean | null;
      } | null;
      media: {
        __typename?: 'VariantMedia';
        mainImage: {
          __typename?: 'Image';
          src: string | null;
          alt: string | null;
        } | null;
        previewImage: {
          __typename?: 'Image';
          src: string | null;
          alt: string | null;
        } | null;
        shadeImage: {
          __typename?: 'Image';
          src: string | null;
          alt: string | null;
        } | null;
        others: Array<{
          __typename?: 'Image';
          src: string | null;
          alt: string | null;
        }>;
        videos: Array<{ __typename?: 'Video'; id: string; type: VideoType }>;
      } | null;
      primaryCategories: {
        __typename?: 'PrimaryCategoryObject';
        category: {
          __typename?: 'CategorizationItem';
          id: number;
          name: string | null;
        } | null;
        kind: {
          __typename?: 'CategorizationItem';
          id: number;
          name: string | null;
        } | null;
        subCategory: {
          __typename?: 'CategorizationItem';
          id: number;
          name: string | null;
        } | null;
        type: {
          __typename?: 'CategorizationItem';
          id: number;
          name: string | null;
        } | null;
      } | null;
      brand: {
        __typename?: 'Brand';
        id: string;
        name: string;
        description: string | null;
        logoUrl: string | null;
        url: string | null;
        market: string | null;
        manufacturer: string | null;
      } | null;
      characteristics: Array<{
        __typename?: 'Characteristic';
        name: string | null;
        help: string | null;
        values: Array<string | null> | null;
        group: string | null;
      }>;
      availability: {
        __typename?: 'Availability';
        state: AvailabilityState;
        maxOrderQuantity: number;
        stockAvailability: StockAvailability;
        availablePickUpStores: number;
      };
      stockAvailability: {
        __typename?: 'StockInfo';
        code: string | null;
        count: number | null;
      };
      campaignConfig: {
        __typename?: 'CampaignConfig';
        allowed: EGiftPackagingAllowedType | null;
        price: number | null;
        groupName: string | null;
      } | null;
      documentation: {
        __typename?: 'ProductDocumentation';
        instructions: string | null;
        warnings: string | null;
        ingredients: string | null;
        foodComposition: string | null;
        specialStorage: string | null;
        manufacturerImporter: string | null;
        importantNotice: string | null;
        preparationUsage: string | null;
        video: { __typename?: 'Video'; id: string; type: VideoType } | null;
        composition: {
          __typename?: 'CompositionTables';
          nutritionValues: Array<{
            __typename?: 'NutritionValue';
            nutritionValue: string | null;
            amountSign: string | null;
            amount: number | null;
            measureUnit: string | null;
            variantAmount: number | null;
          }> | null;
          vitaminsAndMinerals: Array<{
            __typename?: 'VitaminsAndMinerals';
            nutritionValue: string | null;
            amountSign: string | null;
            amount: number | null;
            measureUnit: string | null;
            onePortionAmount: number | null;
            referenceValue: number | null;
            referenceValueOnePercent: number | null;
            referenceValuePercent: number | null;
          }> | null;
        } | null;
        document: {
          __typename?: 'InstructionDocument';
          url: string;
          type: InstructionDocumentType;
        } | null;
      } | null;
    }>;
    deliveries: Array<{
      __typename?: 'ProductDelivery';
      date: string;
      dateFrom: string | null;
      dateTo: string | null;
      delivery: DeliveryType;
      disallowedReason: DeliveryDisallowedReason | null;
      name: string;
      price: number | null;
      icon: string | null;
      thresholdTime: string | null;
      freeShipping: boolean | null;
      limitedFreeShipping: Array<number | null> | null;
    }>;
    categorization: {
      __typename?: 'Categorization';
      kinds: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
      categories: Array<{
        __typename?: 'CategorizationItem';
        id: number;
      }> | null;
      types: Array<{
        __typename?: 'CategorizationItem';
        id: number;
        primary: boolean | null;
      }> | null;
      subCategories: Array<{
        __typename?: 'CategorizationItem';
        id: number;
      }> | null;
    };
    breadcrumb: Array<{
      __typename?: 'Breadcrumb';
      name: string;
      link: string | null;
    }> | null;
    alternateSites: Array<{
      __typename?: 'AlternateSite';
      link: string | null;
      culture: string | null;
    } | null> | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartButton: boolean | null;
      showAddToCartModal: boolean | null;
    };
    primaryCategories: {
      __typename?: 'PrimaryCategoryObject';
      category: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      kind: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      subCategory: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      type: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
    } | null;
    campaigns: Array<{
      __typename?: 'Campaign';
      campaignId: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
    } | null> | null;
  } | null;
  Settings: {
    __typename?: 'Settings';
    imageDomainPath: string;
    deliveriesDisplayMode: string | null;
    showUnitPrices: boolean | null;
    isNewShoppingCartEndpointEnabled: boolean | null;
    featureSwitches: {
      __typename?: 'FeatureSwitches';
      reviewsOnServerIds: string | null;
      addToCartResendDelay: string | null;
      addToCartWarningCount: string | null;
    } | null;
  };
  shopSettings: { __typename?: 'Shop'; countryCode: string } | null;
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
  user: {
    __typename?: 'User';
    id: string | null;
    role: Roles | null;
    cartId: string | null;
    consent: Array<string>;
    comparisonIds: string | null;
    uid: string | null;
    sid: string | null;
    ltag: string | null;
    info: { __typename?: 'UserInfo'; email: string | null } | null;
  } | null;
};

export type GetRecommendedProductsQueryVariables = Exact<{
  productCode: Scalars['String'];
  brandId?: InputMaybe<Scalars['Int']>;
}>;

export type GetRecommendedProductsQuery = {
  __typename?: 'Query';
  recommendedProducts: {
    __typename?: 'ProductRecommendation';
    recommendationAttributes: {
      __typename?: 'RecommendationAttribute';
      attributionToken: string | null;
      provider: string | null;
      recommendationId: string | null;
      engineName: string | null;
    } | null;
    recommendedProducts: Array<{
      __typename?: 'RecommendationProduct';
      productId: string | null;
    } | null> | null;
    failure: { __typename?: 'RecommendationFailure'; message: string } | null;
  } | null;
};

export type CatalogProductDetailViewFragmentFragment = {
  __typename?: 'CatalogProduct';
  webMasterId: string;
  catalogMasterId: string;
  masterProductCode: string;
  description: string | null;
  descriptionType: string | null;
  annotation: string | null;
  subName: string | null;
  collection: string | null;
  url: string;
  gender: Gender | null;
  kind: string | null;
  category: Array<string | null> | null;
  subCategory: Array<string | null> | null;
  type: Array<string | null> | null;
  isPerfume: boolean | null;
  related: Array<number>;
  isForbiddenToDisplay: boolean | null;
  variantDisplayType: VariantDisplayType | null;
  variantGrouppingType: VariantGrouppingType | null;
  brand: {
    __typename?: 'Brand';
    id: string;
    name: string;
    url: string | null;
    description: string | null;
    market: string | null;
    manufacturer: string | null;
    postalAddress: string | null;
    contactAddress: string | null;
    producer: {
      __typename?: 'BrandProducer';
      postalAddress: string | null;
    } | null;
  } | null;
  features: {
    __typename?: 'ProductDetailFeatures';
    isShadeFinderAvailable: boolean | null;
    composition: Array<{
      __typename?: 'Characteristic';
      help: string | null;
      name: string | null;
      values: Array<string | null> | null;
    }> | null;
    availableSets: {
      __typename?: 'ProductAvailableSets';
      sets: Array<{
        __typename?: 'ProductAvailableSet';
        catalogId: number | null;
        type: ProductAvailableSetType | null;
      } | null> | null;
    } | null;
    selfChoiceBox: {
      __typename?: 'SelfChoiceBox';
      sampleProductId: number | null;
    } | null;
    accessories: {
      __typename?: 'ProductAccessories';
      products: Array<{
        __typename?: 'ProductAccessory';
        catalogId: number | null;
      }> | null;
    } | null;
    skinAnalyzer: {
      __typename?: 'SkinAnalyzerFeature';
      banner: string;
      brands: Array<string> | null;
      pageUrl: string;
    } | null;
    hairAnalyzer: {
      __typename?: 'HairAnalyzerFeature';
      banner: string | null;
      brands: Array<string> | null;
    } | null;
  };
  variants: Array<{
    __typename?: 'CatalogVariant';
    webId: string;
    catalogId: string;
    name: string | null;
    variantName: string | null;
    orderCode: string | null;
    productCode: string;
    eanCode: string;
    annotation: string | null;
    additionalInfo: string;
    additionalText: string | null;
    gender: Gender | null;
    url: string;
    attributes: any | null;
    navigationValues: Array<number>;
    descriptionOverride: string | null;
    variantType: string | null;
    colors: Array<string | null> | null;
    wishlisted: boolean | null;
    features: {
      __typename?: 'VariantFeatures';
      availableSets: {
        __typename?: 'ProductAvailableSets';
        sets: Array<{
          __typename?: 'ProductAvailableSet';
          catalogId: number | null;
          type: ProductAvailableSetType | null;
        } | null> | null;
      } | null;
      selfChoiceBox: {
        __typename?: 'SelfChoiceBox';
        sampleProductId: number | null;
      } | null;
      engraving: {
        __typename?: 'Engraving';
        allowed: boolean;
        characterCount: number;
        image: string | null;
        config: {
          __typename?: 'EngravingConfig';
          isAvailable: boolean;
          price: number | null;
        };
      } | null;
      versionedModifaceEffects: Array<{
        __typename?: 'VersionedModifaceEffects';
        apiVersion: string | null;
        type: string | null;
        effects: Array<{
          __typename?: 'GenericModifaceEffect';
          upc: string | null;
          category: string | null;
          shades: any | null;
        } | null> | null;
      } | null> | null;
      perfumers: {
        __typename?: 'Perfumers';
        items: Array<{
          __typename?: 'PerfumerItem';
          name: string;
          imageUrl: string;
        } | null> | null;
      } | null;
    } | null;
    metaData: {
      __typename?: 'Seo';
      title: string | null;
      description: string | null;
      keywords: string | null;
    };
    parameters: {
      __typename?: 'Parameters';
      amount: number | null;
      package: string | null;
      unit: string | null;
    } | null;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    };
    originalPrice: {
      __typename?: 'OriginalPrice';
      value: number | null;
      currency: string | null;
      tax: number | null;
      type: string | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPriceDetail';
      value: number | null;
      currency: string | null;
      tax: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    recentMinPrice: {
      __typename?: 'RecentMinPrice';
      value: number | null;
      currency: string | null;
      tax: number | null;
      isActionEligible: boolean | null;
    } | null;
    media: {
      __typename?: 'VariantMedia';
      mainImage: {
        __typename?: 'Image';
        src: string | null;
        alt: string | null;
      } | null;
      previewImage: {
        __typename?: 'Image';
        src: string | null;
        alt: string | null;
      } | null;
      shadeImage: {
        __typename?: 'Image';
        src: string | null;
        alt: string | null;
      } | null;
      others: Array<{
        __typename?: 'Image';
        src: string | null;
        alt: string | null;
      }>;
      videos: Array<{ __typename?: 'Video'; id: string; type: VideoType }>;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategoryObject';
      category: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      kind: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      subCategory: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
      type: {
        __typename?: 'CategorizationItem';
        id: number;
        name: string | null;
      } | null;
    } | null;
    brand: {
      __typename?: 'Brand';
      id: string;
      name: string;
      description: string | null;
      logoUrl: string | null;
      url: string | null;
      market: string | null;
      manufacturer: string | null;
    } | null;
    characteristics: Array<{
      __typename?: 'Characteristic';
      name: string | null;
      help: string | null;
      values: Array<string | null> | null;
      group: string | null;
    }>;
    availability: {
      __typename?: 'Availability';
      state: AvailabilityState;
      maxOrderQuantity: number;
      stockAvailability: StockAvailability;
      availablePickUpStores: number;
    };
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    };
    campaignConfig: {
      __typename?: 'CampaignConfig';
      allowed: EGiftPackagingAllowedType | null;
      price: number | null;
      groupName: string | null;
    } | null;
    documentation: {
      __typename?: 'ProductDocumentation';
      instructions: string | null;
      warnings: string | null;
      ingredients: string | null;
      foodComposition: string | null;
      specialStorage: string | null;
      manufacturerImporter: string | null;
      importantNotice: string | null;
      preparationUsage: string | null;
      video: { __typename?: 'Video'; id: string; type: VideoType } | null;
      composition: {
        __typename?: 'CompositionTables';
        nutritionValues: Array<{
          __typename?: 'NutritionValue';
          nutritionValue: string | null;
          amountSign: string | null;
          amount: number | null;
          measureUnit: string | null;
          variantAmount: number | null;
        }> | null;
        vitaminsAndMinerals: Array<{
          __typename?: 'VitaminsAndMinerals';
          nutritionValue: string | null;
          amountSign: string | null;
          amount: number | null;
          measureUnit: string | null;
          onePortionAmount: number | null;
          referenceValue: number | null;
          referenceValueOnePercent: number | null;
          referenceValuePercent: number | null;
        }> | null;
      } | null;
      document: {
        __typename?: 'InstructionDocument';
        url: string;
        type: InstructionDocumentType;
      } | null;
    } | null;
  }>;
  deliveries: Array<{
    __typename?: 'ProductDelivery';
    date: string;
    dateFrom: string | null;
    dateTo: string | null;
    delivery: DeliveryType;
    disallowedReason: DeliveryDisallowedReason | null;
    name: string;
    price: number | null;
    icon: string | null;
    thresholdTime: string | null;
    freeShipping: boolean | null;
    limitedFreeShipping: Array<number | null> | null;
  }>;
  categorization: {
    __typename?: 'Categorization';
    kinds: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
    categories: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
    types: Array<{
      __typename?: 'CategorizationItem';
      id: number;
      primary: boolean | null;
    }> | null;
    subCategories: Array<{
      __typename?: 'CategorizationItem';
      id: number;
    }> | null;
  };
  breadcrumb: Array<{
    __typename?: 'Breadcrumb';
    name: string;
    link: string | null;
  }> | null;
  alternateSites: Array<{
    __typename?: 'AlternateSite';
    link: string | null;
    culture: string | null;
  } | null> | null;
  config: {
    __typename?: 'ProductConfig';
    showAddToCartButton: boolean | null;
    showAddToCartModal: boolean | null;
  };
  primaryCategories: {
    __typename?: 'PrimaryCategoryObject';
    category: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    kind: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    subCategory: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    type: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
  } | null;
  campaigns: Array<{
    __typename?: 'Campaign';
    campaignId: string | null;
    detailPageText: string | null;
    displayOnDetailPage: boolean | null;
    giftImageUrl: string | null;
    giftType: GiftType | null;
    productId: string | null;
    name: string | null;
    imageUrl: string | null;
    text: string | null;
  } | null> | null;
};

export type CatalogVariantFragmentFragment = {
  __typename?: 'CatalogVariant';
  webId: string;
  catalogId: string;
  name: string | null;
  variantName: string | null;
  orderCode: string | null;
  productCode: string;
  eanCode: string;
  annotation: string | null;
  additionalInfo: string;
  additionalText: string | null;
  gender: Gender | null;
  url: string;
  attributes: any | null;
  navigationValues: Array<number>;
  descriptionOverride: string | null;
  variantType: string | null;
  colors: Array<string | null> | null;
  wishlisted: boolean | null;
  features: {
    __typename?: 'VariantFeatures';
    availableSets: {
      __typename?: 'ProductAvailableSets';
      sets: Array<{
        __typename?: 'ProductAvailableSet';
        catalogId: number | null;
        type: ProductAvailableSetType | null;
      } | null> | null;
    } | null;
    selfChoiceBox: {
      __typename?: 'SelfChoiceBox';
      sampleProductId: number | null;
    } | null;
    engraving: {
      __typename?: 'Engraving';
      allowed: boolean;
      characterCount: number;
      image: string | null;
      config: {
        __typename?: 'EngravingConfig';
        isAvailable: boolean;
        price: number | null;
      };
    } | null;
    versionedModifaceEffects: Array<{
      __typename?: 'VersionedModifaceEffects';
      apiVersion: string | null;
      type: string | null;
      effects: Array<{
        __typename?: 'GenericModifaceEffect';
        upc: string | null;
        category: string | null;
        shades: any | null;
      } | null> | null;
    } | null> | null;
    perfumers: {
      __typename?: 'Perfumers';
      items: Array<{
        __typename?: 'PerfumerItem';
        name: string;
        imageUrl: string;
      } | null> | null;
    } | null;
  } | null;
  metaData: {
    __typename?: 'Seo';
    title: string | null;
    description: string | null;
    keywords: string | null;
  };
  parameters: {
    __typename?: 'Parameters';
    amount: number | null;
    package: string | null;
    unit: string | null;
  } | null;
  price: {
    __typename?: 'Price';
    value: number | null;
    currency: string | null;
    tax: number | null;
  };
  originalPrice: {
    __typename?: 'OriginalPrice';
    value: number | null;
    currency: string | null;
    tax: number | null;
    type: string | null;
  } | null;
  unitPrice: {
    __typename?: 'UnitPriceDetail';
    value: number | null;
    currency: string | null;
    tax: number | null;
    unit: string | null;
    perAmount: number | null;
  } | null;
  recentMinPrice: {
    __typename?: 'RecentMinPrice';
    value: number | null;
    currency: string | null;
    tax: number | null;
    isActionEligible: boolean | null;
  } | null;
  media: {
    __typename?: 'VariantMedia';
    mainImage: {
      __typename?: 'Image';
      src: string | null;
      alt: string | null;
    } | null;
    previewImage: {
      __typename?: 'Image';
      src: string | null;
      alt: string | null;
    } | null;
    shadeImage: {
      __typename?: 'Image';
      src: string | null;
      alt: string | null;
    } | null;
    others: Array<{
      __typename?: 'Image';
      src: string | null;
      alt: string | null;
    }>;
    videos: Array<{ __typename?: 'Video'; id: string; type: VideoType }>;
  } | null;
  primaryCategories: {
    __typename?: 'PrimaryCategoryObject';
    category: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    kind: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    subCategory: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
    type: {
      __typename?: 'CategorizationItem';
      id: number;
      name: string | null;
    } | null;
  } | null;
  brand: {
    __typename?: 'Brand';
    id: string;
    name: string;
    description: string | null;
    logoUrl: string | null;
    url: string | null;
    market: string | null;
    manufacturer: string | null;
  } | null;
  characteristics: Array<{
    __typename?: 'Characteristic';
    name: string | null;
    help: string | null;
    values: Array<string | null> | null;
    group: string | null;
  }>;
  availability: {
    __typename?: 'Availability';
    state: AvailabilityState;
    maxOrderQuantity: number;
    stockAvailability: StockAvailability;
    availablePickUpStores: number;
  };
  stockAvailability: {
    __typename?: 'StockInfo';
    code: string | null;
    count: number | null;
  };
  campaignConfig: {
    __typename?: 'CampaignConfig';
    allowed: EGiftPackagingAllowedType | null;
    price: number | null;
    groupName: string | null;
  } | null;
  documentation: {
    __typename?: 'ProductDocumentation';
    instructions: string | null;
    warnings: string | null;
    ingredients: string | null;
    foodComposition: string | null;
    specialStorage: string | null;
    manufacturerImporter: string | null;
    importantNotice: string | null;
    preparationUsage: string | null;
    video: { __typename?: 'Video'; id: string; type: VideoType } | null;
    composition: {
      __typename?: 'CompositionTables';
      nutritionValues: Array<{
        __typename?: 'NutritionValue';
        nutritionValue: string | null;
        amountSign: string | null;
        amount: number | null;
        measureUnit: string | null;
        variantAmount: number | null;
      }> | null;
      vitaminsAndMinerals: Array<{
        __typename?: 'VitaminsAndMinerals';
        nutritionValue: string | null;
        amountSign: string | null;
        amount: number | null;
        measureUnit: string | null;
        onePortionAmount: number | null;
        referenceValue: number | null;
        referenceValueOnePercent: number | null;
        referenceValuePercent: number | null;
      }> | null;
    } | null;
    document: {
      __typename?: 'InstructionDocument';
      url: string;
      type: InstructionDocumentType;
    } | null;
  } | null;
};

export type GetCaptchaSiteKeyQueryVariables = Exact<{ [key: string]: never }>;

export type GetCaptchaSiteKeyQuery = {
  __typename?: 'Query';
  AppConfig: {
    __typename?: 'AppConfig';
    captcha: { __typename?: 'CaptchaConfig'; turnstileSiteKey: string | null };
  };
};

export type GetLoadingProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetLoadingProductQuery = {
  __typename?: 'Query';
  vpProductById: {
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    masterProductCode: string | null;
    catalogMasterId: number | null;
    catalogId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    fullAnnotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string; id: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      rating: number;
      count: number;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string | null;
      subCategory: string | null;
      kind: string | null;
      type: string | null;
    };
  } | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type GetReviewOverviewQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type GetReviewOverviewQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    webMasterId: string;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      count: number;
      rating: number;
    } | null;
  } | null;
};

export type GetServicesIncludedQueryVariables = Exact<{
  productsIds: Scalars['String'];
}>;

export type GetServicesIncludedQuery = {
  __typename?: 'Query';
  CartServicesIncluded: {
    __typename?: 'ServicesIncluded';
    engravingShow: boolean;
    tryFirstShow: boolean;
  } | null;
};

export type GetUserEmailClientQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserEmailClientQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    userEmail: string | null;
  } | null;
};

export type GetRichContentForReviewsPageQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
  targetPage: RichContentTargetPage;
}>;

export type GetRichContentForReviewsPageQuery = {
  __typename?: 'Query';
  RichContentByCatalogMasterId: {
    __typename?: 'RichContent';
    isAvailable: boolean;
    content: any | null;
  };
};

export type CopyWishlistMutationVariables = Exact<{
  owner?: InputMaybe<Scalars['String']>;
  anonymousId?: InputMaybe<Scalars['String']>;
}>;

export type CopyWishlistMutation = {
  __typename?: 'Mutation';
  WishlistCopyWishlist: { __typename?: 'WishlistId'; id: string } | null;
};

export type WatchdogRegisteredQueryVariables = Exact<{
  catalogIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type WatchdogRegisteredQuery = {
  __typename?: 'Query';
  watchdogRegistered: {
    __typename?: 'watchdogRegistered';
    registeredEmails: any | null;
  };
};

export type WishlistForCurrentUserQueryVariables = Exact<{
  navigationValues?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  sortBy?: InputMaybe<WishlistSortBy>;
  count?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  wishlist?: InputMaybe<WishlistForCurrentUserWishlistInput>;
  include?: InputMaybe<WishlistForCurrentUserIncludeInput>;
}>;

export type WishlistForCurrentUserQuery = {
  __typename?: 'Query';
  WishlistForCurrentUser: {
    __typename?: 'FilterableWishlist';
    id: string;
    missingProductIds: Array<number>;
    listing: {
      __typename?: 'WishlistListing';
      totalProductCount: number;
      hasMore: boolean;
      sortByOptions: Array<{
        __typename?: 'WishlistSortByOption';
        name: string;
        sortBy: WishlistSortBy;
      }>;
      products: Array<{
        __typename?: 'WishlistProduct';
        webProductId: number;
        product: {
          __typename?: 'VpProduct';
          id: string | null;
          masterId: number | null;
          masterProductCode: string | null;
          catalogMasterId: number | null;
          catalogId: number | null;
          url: string | null;
          imageUrl: string | null;
          name: string | null;
          subName: string | null;
          annotation: string | null;
          fullAnnotation: string | null;
          productCode: string | null;
          wishlisted: boolean | null;
          attributes: any | null;
          showWatchdog: boolean;
          canBuy: boolean;
          price: {
            __typename?: 'Price';
            value: number | null;
            currency: string | null;
            tax: number | null;
          } | null;
          config: {
            __typename?: 'ProductConfig';
            showAddToCartModal: boolean | null;
            showAddToCartButton: boolean | null;
          };
          brand: { __typename?: 'Brand'; name: string; id: string } | null;
          stockAvailability: {
            __typename?: 'StockInfo';
            code: string | null;
            count: number | null;
          } | null;
          unitPrice: {
            __typename?: 'UnitPrice';
            value: number | null;
            unit: string | null;
            perAmount: number | null;
          } | null;
          reviewOverview: {
            __typename?: 'ReviewOverview';
            rating: number;
            count: number;
          } | null;
          primaryCategories: {
            __typename?: 'PrimaryCategories';
            category: string | null;
            subCategory: string | null;
            kind: string | null;
            type: string | null;
          };
        } | null;
      }>;
    };
    filtration: Array<{
      __typename?: 'WishlistFiltration';
      groupName: string;
      groupType: WishlistFiltrationGroupType;
      items: Array<{
        __typename?: 'WishlistFiltrationItem';
        name: string;
        count: number;
        navigationValue: number;
      }>;
    }>;
  } | null;
};

export type WishlistListByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type WishlistListByIdQuery = {
  __typename?: 'Query';
  WishlistListById: {
    __typename?: 'WishlistList';
    id: string;
    name: string | null;
    products: Array<number>;
  } | null;
};

export type AppFeatureSwitchesFragment = {
  __typename?: 'FeatureSwitches';
  reviewsOnServerIds: string | null;
  addToCartResendDelay: string | null;
  addToCartWarningCount: string | null;
};

export type ReviewDataFragment = {
  __typename?: 'Review';
  id: number;
  like: number;
  dislike: number;
  alreadyLiked: boolean;
  alreadyDisliked: boolean;
  score: number;
  text: string | null;
  title: string | null;
  userName: string;
  authorType: AuthorType;
  createdDate: string;
  isAnonymized: boolean;
  originalShopId: string | null;
  sourceLanguage: string | null;
  variantId: number | null;
  partnerDomain: string | null;
  originalText: string | null;
  originalTitle: string | null;
  agency: {
    __typename?: 'ReviewAgency';
    name: string | null;
    url: string | null;
  } | null;
  attributes: {
    __typename?: 'ReviewAttributes';
    pros: Array<string> | null;
    cons: Array<string> | null;
  } | null;
  images: Array<{
    __typename?: 'ReviewImage';
    thumbnailUrl: string | null;
    fullSizeUrl: string;
  }> | null;
};

export type GetModifaceDomainQueryVariables = Exact<{ [key: string]: never }>;

export type GetModifaceDomainQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    modifaceDomain: string | null;
  } | null;
};

export type VirtualTryOnSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VirtualTryOnSettingsQuery = {
  __typename?: 'Query';
  VirtualTryOnSettings: {
    __typename?: 'VtoSettingsResponse';
    licenseKeys: Array<{
      __typename?: 'VtoLicenseKey';
      lookType: string;
      key: string;
    }>;
  } | null;
};

export type GetCurrencyQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrencyQuery = {
  __typename?: 'Query';
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
  };
};

export type GetDefaultDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultDataQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    role: string;
    userId: string;
    userEmail: string | null;
    userName: string | null;
    abTest: string | null;
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    assetsPath: string;
    originUrl: string | null;
    mount: string;
    features: string;
  } | null;
  ProductSsrData: {
    __typename: 'ClientProductSsr';
    id: string | null;
    pathname: string | null;
    type: string | null;
  } | null;
};

export type GetProductImagesQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  idType?: InputMaybe<ProductIdType>;
}>;

export type GetProductImagesQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    imageUrl: string | null;
  } | null>;
};

export type GetMasterProductInfoQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type GetMasterProductInfoQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    webMasterId: string;
    annotation: string | null;
    collection: string | null;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    brand: {
      __typename?: 'Brand';
      id: string;
      name: string;
      description: string | null;
      url: string | null;
      manufacturer: string | null;
      market: string | null;
    } | null;
  } | null;
};

export type GetRequestHeadersQueryVariables = Exact<{ [key: string]: never }>;

export type GetRequestHeadersQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    isGatewayRouterProxyEnabled: boolean;
    traffic: string | null;
    userId: string;
    userName: string | null;
    userEmail: string | null;
    assetsPath: string;
    abTest: string | null;
    newRelicAccountId: string | null;
    newRelicAppId: string | null;
    newRelicBrowserKey: string | null;
    newRelicEnvironment: string | null;
    originUrl: string | null;
    mount: string;
    role: string;
    features: string;
    isPrimaryCurrencyFirst: boolean | null;
    skinAnalyzer: { __typename?: 'SkinAnalyzer'; apiUrl: string; env: string };
    hairAnalyzer: { __typename?: 'HairAnalyzer'; apiUrl: string; env: string };
    secondaryCurrency: {
      __typename?: 'SecondaryCurrency';
      code: string;
      symbol: string;
      exchangeRates: number | null;
      priceFormat: string;
      priceDecimalPlaces: number;
    } | null;
    featureFlags: {
      __typename: 'FeatureFlags';
      dual_currency_price: boolean | null;
      shade_finder_try_it_first_product_master_ids: Array<string> | null;
      livestream_on_pd_enabled: boolean | null;
      strict_sales_display_type: StrictSalesDisplayTypeFeatureFlag | null;
      discovery_box_self_choice_enabled: boolean | null;
      reco_product_detail_add_to_cart: boolean | null;
      reco_product_detail: boolean | null;
      pd_upselling_product_ids_for_testing: Array<string> | null;
      pd_upselling_unmet_voucher_condition: boolean | null;
      pd_should_show_dev_tools: boolean | null;
      experiment_pd_mood_photos_variant: ExperimentMoodPhotosVariant | null;
      experiment_pd_action_percentage_from_rrp: boolean | null;
      experiment_pd_discount_from_rrp_hidden: boolean | null;
      experiment_pd_sticky_atc_button: boolean | null;
      release_pd_sponsored_ads_products: boolean | null;
      release_pd_criteo_rma: boolean | null;
      killswitch_pd_faq: boolean | null;
      experiment_pd_bloomreach_tracking_recommendations: boolean | null;
      experiment_pd_loyalty_gift: boolean | null;
      pd_display_rich_content_as_first_tab_by_ids: {
        __typename?: 'RichContentAsFirstTabFeatureFlag';
        brandIds: Array<string | null> | null;
        masterProductCodes: Array<string | null> | null;
      } | null;
    };
  } | null;
};

export type GetShowUnitPricesQueryVariables = Exact<{ [key: string]: never }>;

export type GetShowUnitPricesQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; showUnitPrices: boolean | null };
};

export type LoggedInUserReviewQueryVariables = Exact<{
  masterProductCode: Scalars['String'];
}>;

export type LoggedInUserReviewQuery = {
  __typename?: 'Query';
  loggedInUserReview: {
    __typename?: 'LoggedInUserReview';
    id: number;
    name: string;
    text: string | null;
    digests: Array<string> | null;
    score: number;
    source: string | null;
    title: string | null;
    variantId: number | null;
    ratings: Array<{
      __typename?: 'ReviewRating';
      id: number;
      ratingType: string;
      score: number;
    }> | null;
    images: Array<{
      __typename?: 'LoggedInUserReviewImages';
      id: string;
      thumbnailUrl: string | null;
    }> | null;
  } | null;
};

export type GetReviewSummaryQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type GetReviewSummaryQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    webMasterId: string;
    reviewSummary: {
      __typename?: 'ReviewSummary';
      averageRating: number;
      totalVotes: number;
      votes: any | null;
      ratings: Array<{
        __typename?: 'ReviewRating';
        id: number;
        score: number;
        preciseScore: number;
        ratingType: string;
      }>;
    } | null;
  } | null;
};

export type GetReviewsQueryVariables = Exact<{
  page: Scalars['Int'];
  orderDesc: Scalars['Boolean'];
  orderBy: ReviewOrderBy;
  masterProductId: Scalars['String'];
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
  contentTypes?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  rating?: InputMaybe<
    Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>
  >;
  variantIds?: InputMaybe<
    Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>
  >;
  shopIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type GetReviewsQuery = {
  __typename?: 'Query';
  reviewsAndFilters: {
    __typename?: 'ReviewsWithFilterResponse';
    data: {
      __typename?: 'ReviewResponseData';
      page: number;
      totalPages: number;
      totalReviews: number;
      reviews: Array<{
        __typename?: 'Review';
        id: number;
        text: string | null;
        userName: string;
        score: number;
        createdDate: string;
        like: number;
        dislike: number;
        alreadyLiked: boolean;
        alreadyDisliked: boolean;
        title: string | null;
        variantId: number | null;
        authorType: AuthorType;
        originalShopId: string | null;
        isAnonymized: boolean;
        sourceLanguage: string | null;
        partnerDomain: string | null;
        originalText: string | null;
        originalTitle: string | null;
        images: Array<{
          __typename?: 'ReviewImage';
          thumbnailUrl: string | null;
          fullSizeUrl: string;
        }> | null;
        attributes: {
          __typename?: 'ReviewAttributes';
          pros: Array<string> | null;
          cons: Array<string> | null;
        } | null;
        agency: {
          __typename?: 'ReviewAgency';
          name: string | null;
          url: string | null;
        } | null;
      }>;
    } | null;
    filter: {
      __typename?: 'ReviewFilter';
      rating: {
        __typename?: 'ReviewRatingBuckets';
        oneStar: number | null;
        twoStar: number | null;
        threeStar: number | null;
        fourStar: number | null;
        fiveStar: number | null;
      } | null;
      contentTypes: Array<{
        __typename?: 'ReviewContentTypeCount';
        type: string | null;
        count: number | null;
      }> | null;
      shops: Array<{
        __typename?: 'ReviewShopCount';
        id: string | null;
        count: number | null;
      }> | null;
      variants: Array<{
        __typename?: 'ReviewVariantCount';
        id: number | null;
        count: number | null;
      }> | null;
    } | null;
  } | null;
};

export type GetFullUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetFullUserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string | null;
    cartId: string | null;
    comparisonIds: string | null;
    role: Roles | null;
    consent: Array<string>;
    uid: string | null;
    sid: string | null;
    ltag: string | null;
    info: { __typename?: 'UserInfo'; email: string | null } | null;
  } | null;
};

export type GetGdprPathsQueryVariables = Exact<{ [key: string]: never }>;

export type GetGdprPathsQuery = {
  __typename?: 'Query';
  shopSettings: {
    __typename?: 'Shop';
    gdprSettings: {
      __typename?: 'GdprSettings';
      termsAndConditionsUrl: string | null;
      securityAndPrivacyUrl: string | null;
    };
  } | null;
};

export type GetUpsellingDataQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetUpsellingDataQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    masterProductCode: string | null;
    catalogMasterId: number | null;
    catalogId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    fullAnnotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string; id: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      rating: number;
      count: number;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string | null;
      subCategory: string | null;
      kind: string | null;
      type: string | null;
    };
  } | null>;
};

export type UpsellingProductsQueryVariables = Exact<{
  productCodes: Array<Scalars['String']> | Scalars['String'];
  brandId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
}>;

export type UpsellingProductsQuery = {
  __typename?: 'Query';
  getUpsellingProductRecommendationsForMultiple: {
    __typename?: 'ProductRecommendation';
    recommendationAttributes: {
      __typename?: 'RecommendationAttribute';
      attributionToken: string | null;
      provider: string | null;
      recommendationId: string | null;
      engineName: string | null;
    } | null;
    recommendedProducts: Array<{
      __typename?: 'RecommendationProduct';
      productId: string | null;
    } | null> | null;
    failure: { __typename?: 'RecommendationFailure'; message: string } | null;
  } | null;
};

export type GetOrderCouponsQueryVariables = Exact<{
  orderCouponsInput: OrderCouponsInput;
}>;

export type GetOrderCouponsQuery = {
  __typename?: 'Query';
  GetOrderCoupons: {
    __typename?: 'OrderCoupons';
    invalidCoupons: {
      __typename?: 'InvalidCoupons';
      coupons: Array<{
        __typename?: 'Coupon';
        code: string;
        validationErrors: Array<{
          __typename?: 'CouponValidationErrors';
          minLevels: Array<{
            __typename?: 'CouponMinLevels';
            missing: number;
            threshold: number;
          }> | null;
        }>;
      }> | null;
    } | null;
  } | null;
};

export type GetProductByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetProductByIdsQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    annotation: string | null;
    fullAnnotation: string | null;
    productCode: string | null;
    orderUnit: string | null;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
  } | null>;
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
};

export type AddProductsToCartMutationVariables = Exact<{
  products: Array<ProductToCartInput> | ProductToCartInput;
  services?: InputMaybe<Array<CartServiceInput> | CartServiceInput>;
}>;

export type AddProductsToCartMutation = {
  __typename?: 'Mutation';
  AddProductsToCart: {
    __typename?: 'AddProductsResponse';
    productAddResponse: Array<{
      __typename?: 'CartProducts';
      productId: number;
      itemId: number;
      messages: Array<string>;
      productIncrease: number;
      cart: {
        __typename?: 'CartContent';
        cartId: string;
        products: Array<{
          __typename?: 'CartContentProduct';
          count: number;
          itemId: number;
          productId: number;
        } | null> | null;
      };
    } | null> | null;
    serviceAddResponse: Array<{
      __typename?: 'CartServiceAddResponse';
      status: Array<CartProductStatus | null>;
      service: {
        __typename?: 'CartAddedService';
        type: CartServiceType | null;
      } | null;
    } | null> | null;
  };
};

export type AddToCartSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type AddToCartSettingsQuery = {
  __typename?: 'Query';
  Settings: {
    __typename?: 'Settings';
    isNewShoppingCartEndpointEnabled: boolean | null;
    featureSwitches: {
      __typename?: 'FeatureSwitches';
      addToCartResendDelay: string | null;
      addToCartWarningCount: string | null;
    } | null;
  };
};

export type GetUserQueryVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  userProductsInfo: Array<{
    __typename?: 'UserProductInfo';
    productId: string | null;
    isComparison: boolean | null;
  } | null> | null;
};

export type GetRequestInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetRequestInfoQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    xUserToken: string | null;
    gatewayUrl: string;
  } | null;
};

export type CreateWatchdogMutationVariables = Exact<{
  catalogId: Scalars['Int'];
  email: Scalars['String'];
}>;

export type CreateWatchdogMutation = {
  __typename?: 'Mutation';
  createWatchdog: {
    __typename?: 'WatchDog';
    success: boolean;
    errors: Array<string> | null;
  };
};

export type WatchdogStateQueryVariables = Exact<{
  catalogId: Scalars['Int'];
}>;

export type WatchdogStateQuery = {
  __typename?: 'Query';
  watchdogState: { __typename?: 'WatchdogActive'; watchdogActive: boolean };
};

export type TestCampaignsQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type TestCampaignsQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename: 'CatalogProduct';
    campaigns: Array<{
      __typename: 'Campaign';
      campaignId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
    } | null> | null;
  } | null;
};

export type TestProductDetailByMasterIdQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type TestProductDetailByMasterIdQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename: 'CatalogProduct';
    webMasterId: string;
    url: string;
    collection: string | null;
    annotation: string | null;
    subName: string | null;
    masterProductCode: string;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    description: string | null;
    related: Array<number>;
    isPerfume: boolean | null;
    isForbiddenToDisplay: boolean | null;
    variantDisplayType: VariantDisplayType | null;
    brand: {
      __typename: 'Brand';
      id: string;
      name: string;
      description: string | null;
      url: string | null;
      market: string | null;
      manufacturer: string | null;
    } | null;
    breadcrumb: Array<{
      __typename: 'Breadcrumb';
      name: string;
      link: string | null;
    }> | null;
    campaigns: Array<{
      __typename: 'Campaign';
      id: string | null;
      campaignId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
    } | null> | null;
    alternateSites: Array<{
      __typename: 'AlternateSite';
      link: string | null;
      culture: string | null;
    } | null> | null;
    deliveries: Array<{
      __typename: 'ProductDelivery';
      name: string;
      date: string;
      delivery: DeliveryType;
      disallowedReason: DeliveryDisallowedReason | null;
    }>;
    reviewOverview: {
      __typename: 'ReviewOverview';
      count: number;
      textReviewsCount: number;
      translatedReviewsCount: number;
      rating: number;
    } | null;
    variants: Array<{
      __typename?: 'CatalogVariant';
      webId: string;
      features: {
        __typename?: 'VariantFeatures';
        engraving: { __typename?: 'Engraving'; allowed: boolean } | null;
      } | null;
    }>;
  } | null;
};

export type TestSendWatchDogMutationVariables = Exact<{
  catalogId: Scalars['Int'];
  email: Scalars['String'];
}>;

export type TestSendWatchDogMutation = {
  __typename?: 'Mutation';
  createWatchdog: {
    __typename?: 'WatchDog';
    success: boolean;
    errors: Array<string> | null;
  };
};

export type GetDefaultQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultQueryQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    groupId: string;
    role: string;
    userId: string;
    userEmail: string | null;
    userName: string | null;
    traffic: string | null;
    abTest: string | null;
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    isGatewayRouterProxyEnabled: boolean;
    assetsPath: string;
    modifaceDomain: string | null;
    shadefinderAppId: string | null;
    newRelicAccountId: string | null;
    newRelicAppId: string | null;
    newRelicBrowserKey: string | null;
    newRelicEnvironment: string | null;
    originUrl: string | null;
    mount: string;
    features: string;
    isPrimaryCurrencyFirst: boolean | null;
    lastVisitedProducts: Array<string> | null;
    skinAnalyzer: { __typename?: 'SkinAnalyzer'; apiUrl: string; env: string };
    hairAnalyzer: { __typename?: 'HairAnalyzer'; apiUrl: string; env: string };
    secondaryCurrency: {
      __typename?: 'SecondaryCurrency';
      code: string;
      symbol: string;
      exchangeRates: number | null;
      priceFormat: string;
      priceDecimalPlaces: number;
    } | null;
    featureFlags: {
      __typename: 'FeatureFlags';
      dual_currency_price: boolean | null;
      shade_finder_try_it_first_product_master_ids: Array<string> | null;
      livestream_on_pd_enabled: boolean | null;
      strict_sales_display_type: StrictSalesDisplayTypeFeatureFlag | null;
      discovery_box_self_choice_enabled: boolean | null;
      reco_product_detail_add_to_cart: boolean | null;
      reco_product_detail: boolean | null;
      pd_upselling_product_ids_for_testing: Array<string> | null;
      pd_upselling_unmet_voucher_condition: boolean | null;
      pd_should_show_dev_tools: boolean | null;
      experiment_pd_mood_photos_variant: ExperimentMoodPhotosVariant | null;
      experiment_pd_action_percentage_from_rrp: boolean | null;
      experiment_pd_discount_from_rrp_hidden: boolean | null;
      experiment_pd_sticky_atc_button: boolean | null;
      release_pd_sponsored_ads_products: boolean | null;
      release_pd_criteo_rma: boolean | null;
      killswitch_pd_faq: boolean | null;
      experiment_pd_bloomreach_tracking_recommendations: boolean | null;
      experiment_pd_loyalty_gift: boolean | null;
      pd_display_rich_content_as_first_tab_by_ids: {
        __typename?: 'RichContentAsFirstTabFeatureFlag';
        brandIds: Array<string | null> | null;
        masterProductCodes: Array<string | null> | null;
      } | null;
    };
  } | null;
  ProductSsrData: {
    __typename: 'ClientProductSsr';
    id: string | null;
    pathname: string | null;
    type: string | null;
  } | null;
};

export type GetProductInfoQueryVariables = Exact<{
  catalogMasterId: Scalars['String'];
}>;

export type GetProductInfoQuery = {
  __typename?: 'Query';
  productDetailByCatalogMasterId: {
    __typename?: 'CatalogProduct';
    variants: Array<{
      __typename?: 'CatalogVariant';
      webId: string;
      catalogId: string;
      attributes: any | null;
      media: {
        __typename?: 'VariantMedia';
        mainImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        } | null;
      } | null;
      metaData: {
        __typename?: 'Seo';
        title: string | null;
        description: string | null;
        keywords: string | null;
      };
      stockAvailability: {
        __typename?: 'StockInfo';
        count: number | null;
        code: string | null;
      };
    }>;
  } | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};
